import {DisplayMatrix, DisplayTypeEnum, Inches, RenderV2_DisplayItem, RenderV2Object} from '../../renderV2/frame-builder/render-v2-d';
import * as Util from '../../util';
import {DocumentSizeTierData} from '../data';
import {DefaultPCS, DocStackingSizeTiers, DYF_FrameStylesEnum, EPBorderType, EPMethod, InsigniaPositionEnum, PCS_CSS, ProductCustomizationState} from './render.def';
// IMPORTANT: MUST NOT import from s.ts (product store) - this renderer code is used in multiple apps for image rendering

declare var __high_res: boolean;

export namespace r {
    export const renderStandardPrimaryMat = (FramePartDomain: string, PMatWidthPX: number, PMatHeightPX: number, MaxMouldingWidthPx: number, MouldingWidthPx: number, pcs: ProductCustomizationState): void => {
        pcs.css.pmat_BackgroundImage = pmat_path(FramePartDomain, PMatWidthPX, pcs.PrimaryMatName).toLowerCase();
        pcs.css.pmat_width = `${PMatWidthPX.toString()}px`;
        pcs.css.pmat_height = `${PMatHeightPX.toString()}px`;
        pcs.css.pmat_backgroundSize = `${PMatWidthPX.toString()}px ${PMatHeightPX.toString()}px`;
        pcs.css.pmat_top = `${MouldingWidthPx.toString()}px`;
        pcs.css.pmat_left = `${MouldingWidthPx.toString()}px`;
    };
    export const pmat_path = (FramePartDomain: string, n: number, v: string): string => {
        let x = 'original';
        if (!__high_res && n >= 0 && n <= 320) {
            x = '160';
        } else if (!__high_res && n >= 321 && n <= 640) {
            x = '320';
        } else if (!__high_res && n >= 641 && n <= 1280) {
            x = '640';
        }
        return `${FramePartDomain}primarymat/v2/${v}_${x}.jpg`.toLowerCase();
    };

    export const renderStandardMoulding = (MouldingWidthPx: number, PMatWidthPx: number, PMatHeightPx: number, pcs: ProductCustomizationState): void => {
        pcs.css.m_topleft_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_topleftcorner.jpg`.toLowerCase();
        pcs.css.m_topleft_left = `-${MouldingWidthPx.toString()}px`;
        pcs.css.m_topleft_top = `-${MouldingWidthPx.toString()}px`;
        pcs.css.m_topleft_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_topright_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_toprightcorner.jpg`.toLowerCase();
        pcs.css.m_topright_left = `${PMatWidthPx.toString()}px`;
        pcs.css.m_topright_top = `-${MouldingWidthPx.toString()}px`;
        pcs.css.m_topright_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_bottomleft_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_bottomleftcorner.jpg`.toLowerCase();
        pcs.css.m_bottomleft_left = `-${MouldingWidthPx.toString()}px`;
        pcs.css.m_bottomleft_top = `${PMatHeightPx.toString()}px`;
        pcs.css.m_bottomleft_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_bottomright_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_bottomrightcorner.jpg`.toLowerCase();
        pcs.css.m_bottomright_left = `${PMatWidthPx.toString()}px`;
        pcs.css.m_bottomright_top = `${PMatHeightPx.toString()}px`;
        pcs.css.m_bottomright_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_left_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_leftside.jpg`.toLowerCase();
        pcs.css.m_left_left = `-${MouldingWidthPx.toString()}px`;
        pcs.css.m_left_top = `0px`;
        pcs.css.m_left_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_left_height = `${PMatHeightPx.toString()}px`;
        pcs.css.m_right_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_rightside.jpg`.toLowerCase();
        pcs.css.m_right_left = `${PMatWidthPx.toString()}px`;
        pcs.css.m_right_top = `0px`;
        pcs.css.m_right_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_right_height = `${PMatHeightPx.toString()}px`;
        pcs.css.m_top_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_topside.jpg`.toLowerCase();
        pcs.css.m_top_left = `0px`;
        pcs.css.m_top_top = `-${MouldingWidthPx.toString()}px`;
        pcs.css.m_top_width = `${PMatWidthPx.toString()}px`;
        pcs.css.m_top_height = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_bottom_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_bottomside.jpg`.toLowerCase();
        pcs.css.m_bottom_left = `0px`;
        pcs.css.m_bottom_top = `${PMatHeightPx.toString()}px`;
        pcs.css.m_bottom_width = `${PMatWidthPx.toString()}px`;
        pcs.css.m_bottom_height = `${MouldingWidthPx.toString()}px`;
    };

    export const doc_path = (pcs: ProductCustomizationState, n: number, DocHeightPx: number, docName: string | null, Base_ExtraEntityName: string | null, DYF_FrameStyleID: number, override: string | null, forcePhoto: boolean = false): string => {
        if (override && override.length > 2 && pcs.image_uploaded) {
            return override;
        }

        if (DYF_FrameStyleID === 10 || forcePhoto) {
            let x = n >= DocHeightPx ? `original` : `original_cropped`;
            if (!__high_res && n >= 0 && n <= 75) {
                x = '150';
            } else if (!__high_res && n >= 76 && n <= 175) {
                x = '350';
            }
            return `${pcs.FramePartDomain}photoframe_photo/v2/${Base_ExtraEntityName}${n >= DocHeightPx ? `_h_` : `_v_`}${x}.png`.toLowerCase();
        } else {
            let x = 'original';
            if (!__high_res && n >= 0 && n <= 75) {
                x = '150';
            } else if (!__high_res && n >= 76 && n <= 175) {
                x = '350';
            }
            return `${pcs.FramePartDomain}document/v2/${docName}${n >= DocHeightPx ? `_h_` : `_v_`}${x}.png`.toLowerCase();
        }
    };
    export const vl_path = (FramePartDomain: string, n: number, VLHeightPx: number, VLName: string | null): string => {
        let x = 'original';
        if (!__high_res && n >= 0 && n <= 75) {
            x = '150';
        } else if (!__high_res && n >= 76 && n <= 175) {
            x = '350';
        }
        return `${FramePartDomain}varsity_letter/v2/${VLName}${n >= VLHeightPx ? `_h_` : `_v_`}${x}.png`.toLowerCase();
    };

    export const oval_path = (FramePartDomain: string, n: number, OvalName: string | null, DYF_FrameStyleID: number): string => {
        let x = 'original';
        if (!__high_res && n >= 0 && n <= 50) {
            x = '100';
        } else if (!__high_res && n >= 51 && n <= 100) {
            x = '200';
        }
        return `${FramePartDomain}${DYF_FrameStyleID == 5 ? `sports` : `portrait`}_oval/v2/${OvalName}_${x}.png`.toLowerCase();
    };

    export const campus_path = (FramePartDomain: string, Base_ExtraEntityName: string | null): string => {
        return `${FramePartDomain}campus_photo/v2/${Base_ExtraEntityName}_original.png`.toLowerCase();
    };

    export const cameo_path = (FramePartDomain: string, n: number, v: string | null): string => {
        let x = '300';
        if (!__high_res && n >= 0 && n <= 37) {
            x = '75';
        } else if (!__high_res && n >= 38 && n <= 75) {
            x = '150';
        }
        return `${FramePartDomain}cameo_photo/v2/${v}_${x}.png`.toLowerCase();
    };

    export const renderCollapsedPMatBevel = (pcs: ProductCustomizationState): void => {
        pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
        pcs.css.doc1_pmat_bevel_left = `0px`;
        pcs.css.doc1_pmat_bevel_top = `0px`;
        pcs.css.doc1_pmat_bevel_width = ``;
        pcs.css.doc1_pmat_bevel_height = ``;
    };

    export const renderCollapsedSMat = (pcs: ProductCustomizationState): void => {
        pcs.css.doc1_smat_backgroundColor = `none`;
        pcs.css.doc1_smat_left = `0px`;
        pcs.css.doc1_smat_top = `0px`;
        pcs.css.doc1_smat_width = ``;
        pcs.css.doc1_smat_height = ``;
        pcs.css.doc1_smat_bevel_backgroundColor = `none`;
        pcs.css.doc1_smat_bevel_left = `0px`;
        pcs.css.doc1_smat_bevel_top = `0px`;
        pcs.css.doc1_smat_bevel_width = ``;
        pcs.css.doc1_smat_bevel_height = ``;
    };

    export const RenderStandardSMat = (BevelWidthPx: number, SMatWidthPx: number, DocWidthPx: number, DocHeightPx: number, pcs: ProductCustomizationState): void => {
        pcs.css.doc1_smat_backgroundColor = `#${pcs.SecondaryMatColor}`;
        pcs.css.doc1_smat_left = `${BevelWidthPx.toString()}px`;
        pcs.css.doc1_smat_top = `${BevelWidthPx.toString()}px`;
        pcs.css.doc1_smat_width = `${(DocWidthPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
        pcs.css.doc1_smat_height = `${(DocHeightPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
        pcs.css.doc1_smat_bevel_backgroundColor = `white`;
        pcs.css.doc1_smat_bevel_left = `${SMatWidthPx.toString()}px`;
        pcs.css.doc1_smat_bevel_top = `${SMatWidthPx.toString()}px`;
        pcs.css.doc1_smat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
        pcs.css.doc1_smat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
    };

    export const renderStandardFillet = (RailSidePx: number, RailTopPx: number, WoodFilletWidthPx: number, DocWidthPx: number, DocHeightPx: number, pcs: ProductCustomizationState): void => {
        pcs.css.f_container_left = `${(RailSidePx - WoodFilletWidthPx).toString()}px`;
        pcs.css.f_container_top = `${(RailTopPx - WoodFilletWidthPx).toString()}px`;
        pcs.css.f_container_width = `${(DocWidthPx - WoodFilletWidthPx * 2).toString()}px`;
        pcs.css.f_container_height = `${(DocHeightPx - WoodFilletWidthPx * 2).toString()}px`;
        pcs.css.f_topleft_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_topleftcorner.png`.toLowerCase();
        pcs.css.f_topleft_left = `0px`;
        pcs.css.f_topleft_top = `0px`;
        pcs.css.f_topleft_width = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_topright_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_toprightcorner.png`.toLowerCase();
        pcs.css.f_topright_left = `${(DocWidthPx + WoodFilletWidthPx).toString()}px`;
        pcs.css.f_topright_top = `0px`;
        pcs.css.f_topright_width = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_bottomleft_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_bottomleftcorner.png`.toLowerCase();
        pcs.css.f_bottomleft_left = `0px`;
        pcs.css.f_bottomleft_top = `${(DocHeightPx + WoodFilletWidthPx).toString()}px`;
        pcs.css.f_bottomleft_width = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_bottomright_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_bottomrightcorner.png`.toLowerCase();
        pcs.css.f_bottomright_left = `${(DocWidthPx + WoodFilletWidthPx).toString()}px`;
        pcs.css.f_bottomright_top = `${(DocHeightPx + WoodFilletWidthPx).toString()}px`;
        pcs.css.f_bottomright_width = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_left_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_leftside.png`.toLowerCase();
        pcs.css.f_left_left = `0px`;
        pcs.css.f_left_top = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_left_width = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_left_height = `${DocHeightPx.toString()}px`;
        pcs.css.f_right_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_rightside.png`.toLowerCase();
        pcs.css.f_right_left = `${(DocWidthPx + WoodFilletWidthPx).toString()}px`;
        pcs.css.f_right_top = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_right_width = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_right_height = `${DocHeightPx.toString()}px`;
        pcs.css.f_top_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_topside.png`.toLowerCase();
        pcs.css.f_top_left = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_top_top = `0px`;
        pcs.css.f_top_width = `${DocWidthPx.toString()}px`;
        pcs.css.f_top_height = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_bottom_src = `${pcs.FramePartDomain}woodfillet/v2/${pcs.SecondaryMatName}_original_bottomside.png`.toLowerCase();
        pcs.css.f_bottom_left = `${WoodFilletWidthPx.toString()}px`;
        pcs.css.f_bottom_top = `${(DocHeightPx + WoodFilletWidthPx).toString()}px`;
        pcs.css.f_bottom_width = `${DocWidthPx.toString()}px`;
        pcs.css.f_bottom_height = `${WoodFilletWidthPx.toString()}px`;
    };

    export const renderStandardInsignia = (FilletCount: number, WoodFilletWidthPx: number, PMatWidthPx: number, MaxInsigniaWidthPx: number, RailTopPx: number, BevelWidthPx: number, SMatCount: number, SMatWidthPx: number, pcs: ProductCustomizationState): number => {
        pcs.css.insignia_bot_visible = false;
        pcs.css.insignia_visible = pcs.Base_InsigniaID > 0;
        let left: number = -1;
        if (pcs.Base_InsigniaID > 0) {
            pcs.css.insignia_src = insignia_path(pcs.FramePartDomain, MaxInsigniaWidthPx, pcs.Base_InsigniaName);
            left = <number>(<any>Math.floor(<number>(<any>PMatWidthPx) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2));
            pcs.css.insignia_left = `${left}px`;
            pcs.css.insignia_top = `${(<number>(<any>Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx)) - <number>(<any>FilletCount) * (<number>(<any>WoodFilletWidthPx) - <number>(<any>BevelWidthPx))) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))).toString()}px`;
            pcs.css.insignia_width = `${MaxInsigniaWidthPx.toString()}px`;
            pcs.css.insignia_height = `${MaxInsigniaWidthPx.toString()}px`;
            pcs.css.insignia_bot = ``;
        }
        return left;
    };

    export const renderBottomInsignia = (FilletCount: number, WoodFilletWidthPx: number, PMatWidthPx: number, MaxInsigniaWidthPx: number, RailTopPx: number, BevelWidthPx: number, SMatCount: number, SMatWidthPx: number, DocHeight: number, pcs: ProductCustomizationState): number => {
        pcs.css.insignia_visible = false;
        pcs.css.insignia_bot_visible = pcs.Base_InsigniaID > 0;
        let left: number = -1;
        if (pcs.Base_InsigniaID > 0) {
            pcs.css.insignia_src = insignia_path(pcs.FramePartDomain, MaxInsigniaWidthPx, pcs.Base_InsigniaName);
            left = <number>(<any>Math.floor(<number>(<any>PMatWidthPx) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2));
            pcs.css.insignia_left = `${(<number>(<any>Math.floor(<number>(<any>PMatWidthPx) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))).toString()}px`;
            pcs.css.insignia_bot = `${(<number>(<any>Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx)) - <number>(<any>FilletCount) * (<number>(<any>WoodFilletWidthPx) - <number>(<any>BevelWidthPx))) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))).toString()}px`;
            pcs.css.insignia_top = ``;
            pcs.css.insignia_width = `${MaxInsigniaWidthPx.toString()}px`;
            pcs.css.insignia_height = `${MaxInsigniaWidthPx.toString()}px`;
        }
        return left;
    };

    export const renderInsigniaOnBottomMoulding = (
        FilletCount: number,
        WoodFilletWidthPx: number,
        PMatWidthPx: number,
        MaxInsigniaWidthPx: number,
        RailTopPx: number,
        BevelWidthPx: number,
        SMatCount: number,
        SMatWidthPx: number,
        DocHeight: number,
        MouldingHeightPX: number,
        pcs: ProductCustomizationState,
    ): number => {
        pcs.css.insignia_visible = false;
        pcs.css.insignia_bot_visible = pcs.Base_InsigniaID > 0;
        let left: number = -1;
        if (pcs.Base_InsigniaID > 0) {
            MaxInsigniaWidthPx *= 1;
            pcs.css.insignia_src = insignia_path(pcs.FramePartDomain, MaxInsigniaWidthPx, pcs.Base_InsigniaName);
            left = <number>(<any>Math.floor(<number>(<any>PMatWidthPx) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2));
            pcs.css.insignia_left = `${(<number>(<any>Math.floor(<number>(<any>PMatWidthPx) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))).toString()}px`;
            pcs.css.insignia_bot = `${Math.round(MouldingHeightPX / 2 - MaxInsigniaWidthPx / 2)}px`;
            pcs.css.insignia_top = ``;
            pcs.css.insignia_width = `${MaxInsigniaWidthPx.toString()}px`;
            pcs.css.insignia_height = `${MaxInsigniaWidthPx.toString()}px`;
        }
        return left;
    };

    export const renderBottomRightInsignia = (pcs: ProductCustomizationState): void => {
        pcs.css.insignia_br_visible = pcs.Base_InsigniaID > 0;
        if (pcs.Base_InsigniaID > 0) {
            let mod: number = 0.3;
            pcs.css.insignia_br_src = `${pcs.FramePartDomain}insignia/v2/med_full/${pcs.Base_InsigniaName}.png`.toLowerCase();
            pcs.css.insignia_br_right = `-${<number>(<any>(pcs.FrameDisplay_width * mod * 0.4))}px`;
            pcs.css.insignia_br_bot = `-${<number>(<any>(pcs.FrameDisplay_width * mod * 0.6))}px`;
            pcs.css.insignia_br_width = `${pcs.FrameDisplay_width * mod}px`;
            pcs.css.insignia_br_height = `${pcs.FrameDisplay_width * mod}px`;
        }
    };

    export const insignia_path_noBevel = (FramePartDomain: string, n: number, InsigniaName: string | null): string => {
        let x = 'med_full';
        if (!__high_res && n >= 0 && n < 220) {
            x = 'med_220';
        }
        return `${FramePartDomain}insignia/v2/${x}/${InsigniaName}.png`.toLowerCase();
    };

    export const insignia_path = (FramePartDomain: string, n: number, InsigniaName: string | null): string => {
        let x = 'original';
        if (!__high_res && n >= 0 && n < 25) {
            x = '50';
        } else if (!__high_res && n >= 26 && n < 45) {
            x = '90';
        } else if (!__high_res && n >= 46 && n < 110) {
            x = '220';
        } else if (!__high_res && n >= 111 && n < 320) {
            x = '640';
        }
        return `${FramePartDomain}insignia/v2/${InsigniaName}_${x}.png`.toLowerCase();
    };

    export const renderStandardLino = (
        FilletCount: number,
        WoodFilletWidthPx: number,
        BevelWidthPx: number,
        SMatCount: number,
        SMatWidthPx: number,
        RailSidePx: number,
        RailTopPx: number,
        DocWidthPx: number,
        DocHeightPx: number,
        LinoWidthMaxPx: number,
        LinoHeightMaxPx: number,
        pcs: ProductCustomizationState,
    ): number => {
        pcs.css.lino_visible = pcs.Base_LinoID > 0;
        let linoLeft: number = -1;
        if (pcs.Base_LinoID > 0) {
            pcs.css.lino_src = lino_path(LinoWidthMaxPx, pcs);
            linoLeft = <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>LinoWidthMaxPx) / 2));
            pcs.css.lino_left = `${linoLeft}px`;
            pcs.css.lino_top = `${<number>(<any>(RailTopPx + DocHeightPx + BevelWidthPx + SMatCount * (SMatWidthPx + BevelWidthPx) + FilletCount * WoodFilletWidthPx + Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx)) - <number>(<any>FilletCount) * <number>(<any>WoodFilletWidthPx)) / 2 - <number>(<any>LinoHeightMaxPx) / 2)))}px`;
            pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
            pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
        }
        return linoLeft;
    };

    export const renderTopLino = (FilletCount: number, WoodFilletWidthPx: number, BevelWidthPx: number, SMatCount: number, SMatWidthPx: number, RailSidePx: number, DocWidthPx: number, DocHeightPx: number, LinoWidthMaxPx: number, LinoHeightMaxPx: number, pcs: ProductCustomizationState): number => {
        pcs.css.lino_visible = pcs.Base_LinoID > 0;
        let linoLeft: number = -1;
        if (pcs.Base_LinoID > 0) {
            pcs.css.lino_src = lino_path(LinoWidthMaxPx, pcs);
            linoLeft = <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>LinoWidthMaxPx) / 2));
            pcs.css.lino_left = `${linoLeft}px`;
            pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
            pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
            pcs.css.lino_top = `${Math.round(RailSidePx / 2 - LinoHeightMaxPx / 2)}px`;
        }
        return linoLeft;
    };

    export const renderLinoOnTopMoulding = (
        FilletCount: number,
        WoodFilletWidthPx: number,
        BevelWidthPx: number,
        SMatCount: number,
        SMatWidthPx: number,
        RailSidePx: number,
        DocWidthPx: number,
        DocHeightPx: number,
        LinoWidthMaxPx: number,
        LinoHeightMaxPx: number,
        MouldingHeightPX: number,
        pcs: ProductCustomizationState,
    ): number => {
        pcs.css.lino_visible = pcs.Base_LinoID > 0;
        let linoLeft: number = -1;
        if (pcs.Base_LinoID > 0) {
            LinoWidthMaxPx *= 1;
            LinoHeightMaxPx *= 1;
            pcs.css.lino_src = lino_path(LinoWidthMaxPx, pcs);
            linoLeft = <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>LinoWidthMaxPx) / 2));
            pcs.css.lino_left = `${linoLeft}px`;
            pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
            pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
            pcs.css.lino_top = `${Math.round(MouldingHeightPX * -1 - LinoHeightMaxPx / 16 + 6)}px`;
            //pcs.css.lino_top = $"{((int)((MouldingHeightPX * -1) + (LinoHeightMaxPx / 16)))}px";
        }
        return linoLeft;
    };

    export const lino_path = (n: number, pcs: ProductCustomizationState): string => {
        if (pcs.IsCAF || pcs.lino_is_dyf) {
            return `${pcs.FramePartDomain}linotype_caf/v2/${pcs.Base_LinoName.replace(/ /g, '_')}_${pcs.lino_dyf_color}.png`.replace('/occupation_', '').toLowerCase();
        }
        let x = 'original';
        if (!__high_res && n >= 0 && n < 75) {
            x = '150';
        } else if (!__high_res && n >= 76 && n < 175) {
            x = '350';
        }
        return `${pcs.FramePartDomain}linotype_product/v2/${pcs.Base_LinoName}_${x}.png`.replace('/occupation_', '').toLowerCase();
    };

    export const renderEngravedPlate = (Left: number, Top: number, EPWidthPx: number, EPHeightPx: number, BevelWidthPx: number, PMatWidthPx: number, pcs: ProductCustomizationState): void => {
        const isEPSingleDoc = pcs.EPMethodID === EPMethod.SingleDoc;
        const isOverlay = pcs.EPBorderType === EPBorderType.Overlay;
        const isInnerAccent = pcs.EPBorderType === EPBorderType.InnerAccent;
        const innerAccentWidth = 6;
        const innerAccentWidthOuter = innerAccentWidth * 2;

        Top = isInnerAccent ? Top - innerAccentWidth : Top;
        Left = isInnerAccent ? Left - innerAccentWidth : Left;

        const getPMat = (size: number) => {
            const doubleBevel = BevelWidthPx * 2;

            if (isEPSingleDoc) {
                return size - doubleBevel - (isInnerAccent ? innerAccentWidthOuter : 0);
            } else {
                return size + doubleBevel;
            }
        };

        const getEP = (size: number) => {
            const allBevel = BevelWidthPx * 4;

            if (isEPSingleDoc) {
                return `${size - allBevel - (isInnerAccent ? innerAccentWidthOuter : 0)}px`;
            } else {
                return `${size}px`;
            }
        };

        let bevelWidth = EPWidthPx + BevelWidthPx * 4;
        bevelWidth = isInnerAccent ? bevelWidth + innerAccentWidthOuter : bevelWidth;

        let bevelHeight = EPHeightPx + BevelWidthPx * 4;
        bevelHeight = isInnerAccent ? bevelHeight + innerAccentWidthOuter : bevelHeight;

        pcs.css.ep_smat_width = `${bevelWidth - innerAccentWidth - (isEPSingleDoc ? innerAccentWidthOuter * 2 : 0)}px`;
        pcs.css.ep_smat_height = `${bevelHeight - innerAccentWidth - (isEPSingleDoc ? innerAccentWidthOuter * 2 : 0)}px`;

        const epWidth = isInnerAccent ? EPWidthPx - innerAccentWidth : EPWidthPx;
        const epHeight = isInnerAccent ? EPHeightPx - innerAccentWidth : EPHeightPx;

        pcs.css.ep_bevel_backgroundColor = isInnerAccent ? pcs.css.doc1_pmat_bevel_backgroundColor : isOverlay ? '' : 'white';
        pcs.css.ep_bevel_left = isEPSingleDoc ? pcs.css.doc1_pmat_bevel_left : `${Left.toString()}px`;
        pcs.css.ep_bevel_top = isEPSingleDoc ? pcs.css.doc1_pmat_bevel_top : `${Top.toString()}px`;
        pcs.css.ep_bevel_width = isEPSingleDoc ? pcs.css.doc1_pmat_bevel_width : `${bevelWidth.toString()}px`;
        pcs.css.ep_bevel_height = isEPSingleDoc ? pcs.css.doc1_pmat_bevel_height : `${bevelHeight.toString()}px`;
        pcs.css.ep_pmat_backgroundImage = !isOverlay ? `url('${pmat_path(pcs.FramePartDomain, PMatWidthPx, pcs.PrimaryMatName)}')`.toLowerCase() : '';
        pcs.css.ep_pmat_left = isInnerAccent ? '50%' : `${BevelWidthPx}px`;
        pcs.css.ep_pmat_top = isInnerAccent ? '50%' : `${BevelWidthPx}px`;
        pcs.css.ep_pmat_width = `${getPMat(EPWidthPx)}px`;
        pcs.css.ep_pmat_height = `${getPMat(EPHeightPx)}px`;
        pcs.css.ep_backgroundImage = `url('${pcs.FramePartDomain}engravedplate/${pcs.EngravedPlateName}_original_engravedplate.png')`.toLowerCase();
        pcs.css.ep_backgroundSize = `cover`;

        if (pcs.EngravedPlateID === 1099) {
            pcs.css.ep_color = `black`;
        } else if (pcs.EngravedPlateID === 39) {
            pcs.css.ep_color = `silver`;
        } else if (pcs.EngravedPlateID === 33146) {
            pcs.css.ep_color = `white`;
        } else {
            pcs.css.ep_color = `gold`;
        }

        pcs.css.ep_left = `${BevelWidthPx.toString()}px`;
        pcs.css.ep_top = `${BevelWidthPx.toString()}px`;
        pcs.css.ep_width = getEP(epWidth);
        pcs.css.ep_height = getEP(epHeight);

        let EPLineCount: number = pcs.EPMethodID === EPMethod.Extended ? getEPLineCount(pcs) : 3;
        let LineHeight: number = <number>(<any>Math.floor((isInnerAccent ? epHeight : <number>(<any>EPHeightPx)) / EPLineCount));
        let EPTextTop: number = <number>(<any>Math.floor((<number>(<any>EPHeightPx) - <number>(<any>EPLineCount) * <number>(<any>LineHeight)) / 2));

        pcs.css.ep_lines_top = `${EPTextTop.toString()}px`;
        pcs.css.ep_lines_left = `0px`;
        pcs.css.ep_lines_lineHeight = `${LineHeight.toString()}px`;
        pcs.css.ep_lines_fontSize = `${(LineHeight - 1).toString()}px`;
        pcs.css.ep_lines_width = getEP(epWidth);
        pcs.css.ep_lines_height = getEP(epHeight);

        if (pcs.css.lino_visible) {
            pcs.css.ep_visible = false;
        }
    };

    export const tassel_path = (CDNDomain: string, n: number, TasselName: string | null): string => {
        let x = 'original';
        if (!__high_res && n >= 0 && n < 175) {
            x = '59';
        }
        return `https://${CDNDomain}/images/entities/tassel/v2/${TasselName}_${x}.png`.toLowerCase();
    };

    export const getEPLineCount = (pcs: ProductCustomizationState): number => {
        return Array.from({length: 10}, (_, i) => pcs[`EP_${i + 1}`]).filter(v => v && !Util.isNullOrWhiteSpace(v)).length;
    };

    export const ItemID_EndsWithNumber = (str: string): boolean => {
        if (Util.isNullOrWhiteSpace(str)) {
            return false;
        }
        var c = str.slice(-1);
        if (c >= '0' && c <= '9') {
            return true;
        } else {
            return false;
        }
    };

    export const Get_DocumentSizeTierID = (Width: number, Height: number, ProductTypeID: number): number => {
        if (Width > Height) {
            let Temp = Height;
            Height = Width;
            Width = Temp;
        }

        let id: number = 12;
        var arr = DocumentSizeTierData.filter(f => f.Width >= Width && f.Height >= Height);

        // console.log(Width, Height);
        // console.log(arr);

        if (arr.length === 1) {
            return arr[0].DocumentSizeTierID;
        } else if (arr.length > 1) {
            var x = arr[0];
            for (let i = 1; i < arr.length; i++) {
                var f = arr[i];
                if (f.Width >= Width && f.Height >= Height && f.Width < x.Width && f.Height <= x.Height) {
                    x = f;
                }
            }
            id = x.DocumentSizeTierID;
        } else {
            id = 12;
        }

        return id;
    };

    export const getDocSizeTier = (pcs: ProductCustomizationState) => {
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;
        let xDocument_Width = pcs.Document_Width;
        let xDocument_Height = pcs.Document_Height;

        if (xDocument_Width > WidthLimit) {
            let ratio: number = WidthLimit / xDocument_Width;
            xDocument_Width = WidthLimit;
            xDocument_Height = xDocument_Height * ratio;
        }
        if (xDocument_Height > HeightLimit) {
            let ratio: number = HeightLimit / xDocument_Height;
            xDocument_Height = HeightLimit;
            xDocument_Width = xDocument_Width * ratio;
        }

        // We normalized the width/height as that framestyle is driven by height. Height needs to be the smaller.
        let tempWidth: number = xDocument_Width;
        let tempHeight: number = xDocument_Height;
        if (tempHeight > tempWidth) {
            let dTemp: number = xDocument_Height;
            tempHeight = xDocument_Width;
            tempWidth = dTemp;
        }

        var arr = DocStackingSizeTiers.filter(f => f.DocWidth >= tempWidth && f.DocHeight >= tempHeight);

        if (arr == null || arr.length < 1) {
            return DocStackingSizeTiers[DocStackingSizeTiers.length - 1];
        } else if (arr.length === 1) {
            return arr[0];
        } else {
            var x = arr[0];
            for (let i = 1; i < arr.length; i++) {
                var f = arr[i];
                if (f.DocWidth >= tempWidth && f.DocHeight >= tempHeight && f.DocWidth < x.DocWidth && f.DocHeight <= x.DocHeight) {
                    x = f;
                }
            }
            return x;
        }
    };

    export const getDocSizeTier2 = (pcs: ProductCustomizationState) => {
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;
        let xDocument2_Width = pcs.Document2_Width;
        let xDocument2_Height = pcs.Document2_Height;

        if (xDocument2_Width > WidthLimit) {
            let ratio: number = WidthLimit / xDocument2_Width;
            xDocument2_Width = WidthLimit;
            xDocument2_Height = xDocument2_Height * ratio;
        }
        if (xDocument2_Height > HeightLimit) {
            let ratio: number = HeightLimit / xDocument2_Height;
            xDocument2_Height = HeightLimit;
            xDocument2_Width = xDocument2_Width * ratio;
        }

        // We normalized the width/height as that framestyle is driven by height. Height needs to be the smaller.
        let tempWidth: number = xDocument2_Width;
        let tempHeight: number = xDocument2_Height;
        if (tempHeight > tempWidth) {
            let dTemp: number = xDocument2_Height;
            tempHeight = xDocument2_Width;
            tempWidth = dTemp;
        }

        var arr = DocStackingSizeTiers.filter(f => f.DocWidth >= tempWidth && f.DocHeight >= tempHeight);

        if (arr == null || arr.length < 1) {
            return DocStackingSizeTiers[DocStackingSizeTiers.length - 1];
        } else if (arr.length === 1) {
            return arr[0];
        } else {
            var x = arr[0];
            for (let i = 1; i < arr.length; i++) {
                var f = arr[i];
                if (f.DocWidth >= tempWidth && f.DocHeight >= tempHeight && f.DocWidth < x.DocWidth && f.DocHeight <= x.DocHeight) {
                    x = f;
                }
            }
            return x;
        }
    };

    export const linoWidthAdjust = (n: number, pcs: ProductCustomizationState): number => {
        if (pcs.IsCAF || pcs.MaxFrameWidthPx <= 300) {
            return n;
        }
        if (n > 300) {
            if (pcs.Document_Width >= 9 && pcs.Document_Width <= 9.9999) {
                return n * 0.9;
            } else if (pcs.Document_Width >= 10 && pcs.Document_Width <= 13.9999) {
                if (Util.isNullOrWhiteSpace(pcs.ItemID) && !ItemID_EndsWithNumber(pcs.ItemID)) {
                    return n * 0.83;
                } else {
                    return n * 0.9;
                }
            } else if (pcs.Document_Width >= 14 && pcs.Document_Width <= 16) {
                return n * 0.9;
            } else if (pcs.Document_Width >= 16.0001 && pcs.Document_Width <= 50) {
                if (Util.isNullOrWhiteSpace(pcs.ItemID) && !ItemID_EndsWithNumber(pcs.ItemID)) {
                    return n * 0.9;
                } else {
                    return n;
                }
            } else {
                return n * 0.9;
            }
        }
        return n;
    };

    export const render = (pcs: ProductCustomizationState, _renderType: Util.RenderType = Util.RenderType.Normal): PCS_CSS => {
        try {
            pcs.UseCommonDPI = (pcs.MaxFrameWidthPx == 220 && pcs.MaxFrameHeightPx == 250) || pcs.MaxFrameWidthPx == 308;
            pcs.UseMaxMouldingForSizing = false;

            if (_renderType === Util.RenderType.Zoom) {
                pcs.MaxFrameWidthPx = window.innerWidth * 0.8;
                pcs.MaxFrameHeightPx = window.innerHeight * 0.8;
            }

            if (pcs.CustomizationMethodID === 1) {
                render_old_style(pcs, _renderType);
                pcs.css.frame_display_width = pcs.FrameDisplay_width;
                pcs.css.frame_display_height = pcs.FrameDisplay_height;
                return {...pcs.css};
            } else if (pcs.CustomizationMethodID < 1) {
                pcs.css.frame_display_width = pcs.FrameDisplay_width;
                pcs.css.frame_display_height = pcs.FrameDisplay_height;
                return {...pcs.css};
            }

            if (
                pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Single_Document ||
                pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Photo_Frame ||
                pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Spirit ||
                pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.SpiritB ||
                pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Cameo
            ) {
                renderSingleDocFrame(pcs);
            } else if (pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Tassel) {
                renderTasselFrame(pcs);
            } else if (pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Double_Document || pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Campus_Scene) {
                renderDoubleDoc(pcs);
            } else if (pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Varsity) {
                renderVarsity(pcs);
            } else if (pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Sports_Oval || pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Portrait_Oval) {
                renderOvalFrame(pcs);
            } else if (pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.Century) {
                renderCentury(pcs);
            } else if (pcs.DYF_FrameStyleID === DYF_FrameStylesEnum.DoubleStack) {
                renderDoubleStack(pcs);
            }

            pcs.css.body_width = `${(parseInt(pcs.css.m_top_width.replace('px', ''), 10) + parseInt(pcs.css.m_topleft_width.replace('px', ''), 10) + parseInt(pcs.css.m_topleft_width.replace('px', ''), 10)).toString()}px`;
            pcs.css.body_height = `${(parseInt(pcs.css.m_left_height.replace('px', ''), 10) + parseInt(pcs.css.m_topleft_width.replace('px', ''), 10) + parseInt(pcs.css.m_topleft_width.replace('px', ''), 10)).toString()}px`;

            pcs.css.frame_display_width = pcs.FrameDisplay_width;
            pcs.css.frame_display_height = pcs.FrameDisplay_height;

            console.log(pcs.css.body_width);

            return {...pcs.css};
        } catch (err) {
            console.error(err);
            return pcs.css;
        }
    };

    export const renderV2 = (pcs: ProductCustomizationState, _renderType: Util.RenderType = Util.RenderType.Normal): RenderV2Object => {
        type Prefix = 'insignia' | 'doc1' | 'doc2' | 'lino';
        type Display = {
            prefix: Prefix;
            type: DisplayTypeEnum;
        };

        const width = (type: DisplayTypeEnum, prefix: Prefix): number => {
            if (type === DisplayTypeEnum.Insignia) {
                return pcs.Base_InsigniaWidthInches !== -1 ? pcs.Base_InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
            } else if (type === DisplayTypeEnum.Doc) {
                if (prefix === 'doc1') {
                    return pcs.Document_Width;
                } else {
                    return pcs.Document2_Width;
                }
            } else if (type === DisplayTypeEnum.Lino) {
                return -1;
            }

            return -1;
        };

        const height = (type: DisplayTypeEnum, prefix: Prefix): number => {
            if (type === DisplayTypeEnum.Insignia) {
                return -1;
            } else if (type === DisplayTypeEnum.Doc) {
                if (prefix === 'doc1') {
                    return pcs.Document_Height;
                } else {
                    return pcs.Document2_Height;
                }
            } else if (type === DisplayTypeEnum.Lino) {
                return DefaultPCS.DefaultLinoHeightMax;
            }

            return -1;
        };

        const rowSpan = (type: DisplayTypeEnum, prefix: Prefix): number => {
            if (type === DisplayTypeEnum.Insignia) {
                return 1;
            } else if (type === DisplayTypeEnum.Doc) {
                if (prefix === 'doc1') {
                    if (pcs.css.insignia_visible) {
                        return 2;
                    } else {
                        return 1;
                    }
                } else {
                    return 3;
                }
            }

            return 1;
        };

        const gapBelow = (prefix: Prefix): Inches => {
            const gap = prefix === 'doc1' && pcs.css.doc2_visible ? 0.75 : -1;

            return gap as Inches;
        };

        const getDisplayMatrix = (): DisplayMatrix => {
            const {css} = pcs;
            const matrix: DisplayMatrix = [];
            const displayTypes: Display[] = [
                {prefix: 'insignia', type: DisplayTypeEnum.Insignia},
                {prefix: 'doc1', type: DisplayTypeEnum.Doc},
                {prefix: 'doc2', type: DisplayTypeEnum.Doc},
                {prefix: 'lino', type: DisplayTypeEnum.Lino},
            ];

            for (const {prefix, type} of displayTypes) {
                const visible = css[`${prefix}_visible`];

                if (!visible) continue;

                const item: RenderV2_DisplayItem = {
                    displayType: type,
                    width: width(type, prefix) as Inches,
                    height: height(type, prefix) as Inches,
                    url: css[`${prefix}_src`],
                    mat2Color: css[`${prefix}_smat_backgroundColor`] !== 'none' ? css[`${prefix}_smat_backgroundColor`] : null,
                    mat2ImageURL: pcs.css.fillet_visible
                        ? {
                              cornerTopLeftURL: pcs.css.f_topleft_src,
                              cornerTopRightURL: pcs.css.f_topright_src,
                              cornerBottomRightURL: pcs.css.f_bottomright_src,
                              cornerBottomLeftURL: pcs.css.f_bottomleft_src,
                              sideTopURL: pcs.css.f_top_src,
                              sideRightURL: pcs.css.f_right_src,
                              sideBottomURL: pcs.css.f_bottom_src,
                              sideLeftURL: pcs.css.f_left_src,
                          }
                        : null,
                    gapRight: -1 as Inches,
                    gapBelow: gapBelow(prefix),
                    rowSpan: type === DisplayTypeEnum.Lino ? displayTypes.filter(d => css[`${d.prefix}_visible`]).length : rowSpan(type, prefix),
                    colSpan: 1,
                };

                if (item.height !== -1 || item.width !== -1) {
                    matrix.push([item]);
                }
            }

            return matrix;
        };

        const ensureHash = (color: string): string => {
            color = color.trim();

            if (!color.startsWith('#')) {
                color = `#${color}`;
            }

            return color;
        };

        return {
            moulding: {
                mouldingThickness: pcs.MouldingExtWidth as Inches,
                cornerTopLeftURL: pcs.css.m_topleft_src,
                cornerTopRightURL: pcs.css.m_topright_src,
                cornerBottomRightURL: pcs.css.m_bottomright_src,
                cornerBottomLeftURL: pcs.css.m_bottomleft_src,
                sideTopURL: pcs.css.m_top_src,
                sideRightURL: pcs.css.m_right_src,
                sideBottomURL: pcs.css.m_bottom_src,
                sideLeftURL: pcs.css.m_left_src,
            },
            mat1Color: '',
            mat1ImageURL: pcs.css.pmat_BackgroundImage,
            railLeft: 2.25 as Inches,
            railRight: 2.25 as Inches,
            railTop: 2.25 as Inches,
            railBottom: 2.25 as Inches,
            displayMatrix: getDisplayMatrix(),
            spiritMode: pcs.css.spirit_visible
                ? {
                      topCutWidth: pcs.Base_InsigniaWidthInches !== -1 ? pcs.Base_InsigniaWidthInches + 1.5 : DefaultPCS.DefaultInsigniaWidthMax + 1.5,
                      bottomCutWidth: DefaultPCS.DefaultLinoWidthMax - 1.5,
                      outerColor: '#ffffff',
                      innerColor: ensureHash(pcs.SecondaryMatColor),
                  }
                : null,
        };
    };

    export const render_old_style = (pcs: ProductCustomizationState, _renderType: Util.RenderType) => {
        let MouldingWidthPx: number = pcs.MouldingThickness === 1 ? 21 : pcs.MouldingThickness === 2 ? 63 : 42;

        const largept = [2, 6, 8, 44, 45, 46, 47, 59, 64, 9, 19, 9, 60];

        if (pcs.MouldingExtWidth <= 1.375 || pcs.MouldingID == 146 || !pcs.isHorizontal) {
            MouldingWidthPx = 22;
        } else if (pcs.MouldingExtWidth < 2) {
            MouldingWidthPx = 32;
        } else {
            MouldingWidthPx = 50;
        }
        pcs.css.moulding_width = MouldingWidthPx;
        pcs.css.moulding_half = MouldingWidthPx / 2;

        pcs.css.m_topleft_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_topleftcorner.jpg`.toLowerCase();
        pcs.css.m_topleft_left = `0`;
        pcs.css.m_topleft_top = `0`;
        pcs.css.m_topleft_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_topright_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_toprightcorner.jpg`.toLowerCase();
        pcs.css.m_topright_left = ``;
        pcs.css.m_topright_top = `0`;
        pcs.css.m_topright_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_bottomleft_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_bottomleftcorner.jpg`.toLowerCase();
        pcs.css.m_bottomleft_left = `0`;
        pcs.css.m_bottomleft_top = `inherit`;
        pcs.css.m_bottomleft_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_bottomright_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_bottomrightcorner.jpg`.toLowerCase();
        pcs.css.m_bottomright_left = `inherit`;
        pcs.css.m_bottomright_top = `inherit`;
        pcs.css.m_bottomright_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_left_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_leftside.jpg`.toLowerCase();
        pcs.css.m_left_left = `0`;
        pcs.css.m_left_top = `0`;
        pcs.css.m_left_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_left_height = `100%`;
        pcs.css.m_right_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_rightside.jpg`.toLowerCase();
        pcs.css.m_right_left = `inherit`;
        pcs.css.m_right_top = `0`;
        pcs.css.m_right_width = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_right_height = `100%`;
        pcs.css.m_top_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_topside.jpg`.toLowerCase();
        pcs.css.m_top_left = `0px`;
        pcs.css.m_top_top = `0`;
        pcs.css.m_top_height = `${MouldingWidthPx.toString()}px`;
        pcs.css.m_bottom_src = `${pcs.FramePartDomain}moulding/v2/${pcs.MouldingName}_original_bottomside.jpg`.toLowerCase();
        pcs.css.m_bottom_left = `0px`;
        pcs.css.m_bottom_top = `inherit`;
        pcs.css.m_bottom_height = `${MouldingWidthPx.toString()}px`;

        return true;
    };

    const renderSingleDocFrame = (pcs: ProductCustomizationState): void => {
        let CurrentDocWidth: number = 0;
        let CurrentDocHeight: number = 0;
        let DocSizeTier = r.getDocSizeTier(pcs);
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;

        if (pcs.Document_Width > WidthLimit) {
            let ratio: number = WidthLimit / pcs.Document_Width;
            pcs.Document_Width = WidthLimit;
            pcs.Document_Height = pcs.Document_Height * ratio;
        }
        if (pcs.Document_Height > HeightLimit) {
            let ratio: number = HeightLimit / pcs.Document_Height;
            pcs.Document_Height = HeightLimit;
            pcs.Document_Width = pcs.Document_Width * ratio;
        }
        CurrentDocWidth = pcs.Document_Width;
        CurrentDocHeight = pcs.Document_Height;

        let filletCount: number = pcs.MatCombo_IsWoodFillet ? 1 : 0;
        let SMatCount: number = !pcs.MatCombo_IsWoodFillet && pcs.SecondaryMatID > 0 ? 1 : 0;
        let SMatWidthPixelAdder: number = 1;

        // rail Setup
        // - Rail includes: Inner Mat and all mat bevels.
        // - The primary mat is actually the inner mat on single document frames
        // - The document "underlaps" the inner mat. See DocSizeTier.DocOverLap
        // - The mats are overlapped by the moulding by 0.25
        // - From this point forward, rail will be defined as all visible portions of mats including bevels (we are subtracting out the 0.25 of moulding overlap)
        let MouldingOverlap: number = 0.25;
        let RailTop: number = <number>(<any>DocSizeTier.StandardRail) - MouldingOverlap;
        let RailSide: number = <number>(<any>DocSizeTier.StandardRail) - MouldingOverlap;
        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Cameo)) {
            RailTop = <number>(<any>DocSizeTier.CameoRail) - MouldingOverlap;
            RailSide = <number>(<any>DocSizeTier.CameoRail) - MouldingOverlap;
        }
        // else if (pcs.DYF_FrameStyleID == (<number><any>DYF_FrameStylesEnum.Photo_Frame) && pcs.Document_Width <= 10) {
        //     RailTop = 1.625 - MouldingOverlap;
        //     RailSide = 1.625 - MouldingOverlap;
        // }
        // Dim RailSize = CDec(DocSizeTier.CameoRail) - MouldingOverlap
        // insignia Adjustments
        let InsigniaWidth = pcs.Base_InsigniaWidthInches > 0 ? pcs.Base_InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
        console.log(InsigniaWidth);
        // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '1: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit) || pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
            if (pcs.Base_InsigniaWidthInches > 1.9) {
            } else if (CurrentDocWidth < 10 && CurrentDocHeight < 10) {
                InsigniaWidth = Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.5);
                // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '2a: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
            } else if (CurrentDocWidth < 10 || CurrentDocHeight < 10) {
                InsigniaWidth = Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.4);
                // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '2b: {DefaultPCS.DefaultInsigniaWidthMax}:{RailTop}');"; data.fn.ExecuteSQL(sql); }
            }
        } else {
            InsigniaWidth = CurrentDocWidth < 10 && CurrentDocHeight < 10 ? Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.5) : InsigniaWidth;
            // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '2c: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
        }
        InsigniaWidth = DocSizeTier.DocSizeTierID >= 7 && pcs.Base_InsigniaWidthInches < 1 ? 2 : InsigniaWidth;
        console.log(InsigniaWidth);
        // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '3: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
        // lino
        let LinoWidthMax: number = Math.min(DefaultPCS.DefaultLinoWidthMax, CurrentDocWidth + 1) + pcs.Base_LinoAdjustmentInches;
        LinoWidthMax = r.linoWidthAdjust(LinoWidthMax, pcs);
        let LinoHeightMax: number = DefaultPCS.DefaultLinoHeightMax * (LinoWidthMax / 11.5);
        // ****----____ EP-code-change ____----****
        let EPWidth: number = DefaultPCS.DefaultEPWidth;
        let EPHeight: number = DefaultPCS.DefaultEPHeight;
        if (CurrentDocHeight <= 7) {
            EPWidth = 3;
            EPHeight = 0.5;
        }
        // ****----____ EP-code-change ____----****
        let TotalWidth: number = RailSide * 2 + CurrentDocWidth + (pcs.UseMaxMouldingForSizing ? pcs.MouldingWidthMax * 2 : pcs.MouldingExtWidth * 2);
        let DPI: number = <number>(<any>Math.floor((pcs.MaxFrameWidthPx + 4) / TotalWidth)); // add 4. Yes, it's cheating, but we always round down and actually have a bit more room to work with.

        let done: boolean = false;
        let BevelWidthPx: number = -1;
        let DocWidthPx: number = -1;
        let DocHeightPx: number = -1;
        // ****----____ EP-code-change ____----****
        let EPWidthPx: number = -1;
        let EPHeightPx: number = -1;
        // ****----____ EP-code-change ____----****
        let MaxInsigniaWidthPx: number = -1;
        let LinoWidthMaxPx: number = -1;
        let LinoHeightMaxPx: number = -1;
        let MouldingWidthPx: number = -1;
        let MaxMouldingWidthPx: number = -1;
        let SMatWidthPx: number = -1;
        let RailSidePx: number = -1;
        let RailTopPx: number = -1;
        let RailBottomPx: number = -1;
        if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
            SMatWidthPx = 2;
        }
        let TotalUsedWidthPx: number = -1;
        let TotalUsedWidthPx_NoMargin: number = -1;
        let MaxSingleDocRailWidthPx: number = -1;
        let MaxPossibleSingleDocWidthPx: number = -1;
        let MaxPossibleSingleDocHeightPx: number = -1;
        let PMatWidthPx: number = -1;
        let TotalUsedHeightPx: number = -1;
        let TotalUsedHeightPx_NoMargin: number = 1;
        let PMatHeightPx: number = -1;
        let WoodFilletWidthPx: number = -1;
        let DocBevelWidth: number = -1;
        let DocBevelHeight: number = -1;

        while (!done) {
            BevelWidthPx = Math.max(1, <number>(<any>Math.round(pcs.BevelWidth * 2 * DPI))); // double bevel width. It was too small.
            DocWidthPx = <number>(<any>Math.round((CurrentDocWidth - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DocHeightPx = <number>(<any>Math.round((CurrentDocHeight - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            // ****----____ EP-code-change ____----****
            MaxInsigniaWidthPx = <number>(<any>Math.round(InsigniaWidth * DPI));
            console.log(InsigniaWidth);
            LinoWidthMaxPx = <number>(<any>Math.round(LinoWidthMax * DPI));
            LinoHeightMaxPx = <number>(<any>Math.round(LinoHeightMax * DPI));
            MouldingWidthPx = <number>(<any>Math.round(pcs.MouldingExtWidth * DPI));
            MaxMouldingWidthPx = <number>(<any>Math.round(pcs.MouldingWidthMax * DPI));
            pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
            SMatWidthPx = Math.max(1, <number>(<any>Math.floor((pcs.InnerAccentWidth - pcs.BevelWidth) * DPI))) + SMatWidthPixelAdder; // innerAccentWidth includes bevel. We take bevel out here as we convert to pixels. Adding +1 pixel here. We might have to loop back and adjust DPI down
            DocBevelWidth = getDocBevelWidth(SMatCount, DocWidthPx, BevelWidthPx, SMatWidthPx);
            DocBevelHeight = getDocBevelHeight(SMatCount, DocHeightPx, BevelWidthPx, SMatWidthPx);
            EPWidthPx = getEPWidth(pcs, DPI, EPWidth, DocBevelWidth);
            EPHeightPx = getEPHeight(pcs, DPI, EPHeight, DocBevelHeight);
            RailSidePx = <number>(<any>Math.round(RailSide * DPI)) + SMatWidthPixelAdder * SMatCount + filletCount * (BevelWidthPx * 2 + SMatWidthPx); // we add the smat pixel adder because this adder is not accounted for in the core rail size specs. Also, if it is a wood fillet, we must add the wood fillet to the rail size since the fillet is additive
            RailTopPx = <number>(<any>Math.round(RailTop * DPI)) + SMatWidthPixelAdder * SMatCount + filletCount * (BevelWidthPx * 2 + SMatWidthPx);
            RailBottomPx = getRailBottomForDynamicEP(pcs, RailTopPx, EPHeightPx);

            if (pcs.EPMethodID === EPMethod.SingleDoc) {
                pcs.css.doc1_visible = false;
            }

            if (pcs.ProductTypeID == 69 || pcs.ProductTypeID == 85 || pcs.ProductTypeID == 79 || pcs.ProductTypeID == 86) {
                RailSidePx = 0;
                RailTopPx = 0;
            }

            if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
                SMatWidthPx = 2;
            } // Cap SMat at 2px for images at or below 250px// Cap SMat at 2px for images at or below 250px
            TotalUsedWidthPx = RailSidePx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            TotalUsedWidthPx_NoMargin = RailSidePx * 2 + DocWidthPx + MouldingWidthPx * 2;
            // calculate the maximum possible width of a single doc frame with this document size. This is used to establish a common DPI across all single docs when UseCommonDPI is set to true
            MaxSingleDocRailWidthPx = Math.max(
                <number>(<any>Math.round((<number>(<any>DocSizeTier.CameoRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder,
                <number>(<any>Math.round((<number>(<any>DocSizeTier.StandardRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder + (BevelWidthPx * 2 + SMatWidthPx),
            ); // we use the larger cameo rail for this calculation. Also, compare against standard rail + fillet. Take the largest
            MaxPossibleSingleDocWidthPx = MaxSingleDocRailWidthPx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            MaxPossibleSingleDocHeightPx = MaxSingleDocRailWidthPx * 2 + DocHeightPx + MaxMouldingWidthPx * 2;
            PMatWidthPx = TotalUsedWidthPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            TotalUsedHeightPx = RailTopPx + RailBottomPx + DocHeightPx + MaxMouldingWidthPx * 2;
            TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + DocHeightPx + MouldingWidthPx * 2;
            PMatHeightPx = TotalUsedHeightPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            WoodFilletWidthPx = BevelWidthPx * 2 + SMatWidthPx;

            if (DocHeightPx > DocWidthPx && pcs.UseCommonDPI) {
                if (MaxPossibleSingleDocHeightPx > pcs.MaxFrameWidthPx) {
                    DPI -= 1;
                    done = false;
                } else {
                    done = true;
                }
            } else {
                if ((pcs.UseCommonDPI ? MaxPossibleSingleDocWidthPx : TotalUsedWidthPx_NoMargin) > pcs.MaxFrameWidthPx || (pcs.UseCommonDPI ? TotalUsedHeightPx : TotalUsedHeightPx_NoMargin) > pcs.MaxFrameHeightPx) {
                    DPI -= 1;
                    done = false;
                } else {
                    done = true;
                }
            }
        }

        // set DPI to a global object
        pcs.DPI = DPI;
        // check width, look back with new dpi if necessary
        pcs.FrameDisplay_width = TotalUsedWidthPx;
        pcs.FrameDisplay_height = TotalUsedHeightPx;
        // primary mat
        r.renderStandardPrimaryMat(pcs.FramePartDomain, PMatWidthPx, PMatHeightPx, MaxMouldingWidthPx, MouldingWidthPx, pcs);
        r.renderStandardMoulding(MouldingWidthPx, PMatWidthPx, PMatHeightPx, pcs);
        // secondary mat
        pcs.css.fillet_visible = filletCount > 0;
        if (SMatCount > 0) {
            // if there is an inner accent, then the outer mat "pulls back" to make room for the inner mat
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${DocBevelWidth}px`;
            pcs.css.doc1_pmat_bevel_height = `${DocBevelHeight}px`;
            // console.log(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx);
            r.RenderStandardSMat(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx, pcs);
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        } else if (filletCount > 0) {
            // turn off inner mat pieces
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `0px`;
            pcs.css.doc1_pmat_bevel_top = `0px`;
            pcs.css.doc1_pmat_bevel_width = ``;
            pcs.css.doc1_pmat_bevel_height = ``;
            r.renderCollapsedSMat(pcs);
            r.renderStandardFillet(RailSidePx, RailTopPx, WoodFilletWidthPx, DocWidthPx, DocHeightPx, pcs);
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${RailSidePx.toString()}px`;
            pcs.css.doc1_top = `${RailTopPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        } else {
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${DocBevelWidth.toString()}px`;
            pcs.css.doc1_pmat_bevel_height = `${DocBevelHeight.toString()}px`;
            r.renderCollapsedSMat(pcs);
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        }
        // insignia
        let insLeft: number = r.renderStandardInsignia(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, pcs);
        // lino
        let linoLeft: number = -1;
        if (filletCount > 0) {
            pcs.css.lino_visible = pcs.Base_LinoID > 0;
            if (pcs.Base_LinoID != 0) {
                pcs.css.lino_src = r.lino_path(LinoWidthMaxPx, pcs);
                pcs.css.lino_left = `${<number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>LinoWidthMaxPx) / 2))}px`;
                pcs.css.lino_top = `${<number>(<any>(RailTopPx + DocHeightPx + filletCount * WoodFilletWidthPx + Math.floor((<number>(<any>RailTopPx) - <number>(<any>filletCount) * <number>(<any>WoodFilletWidthPx)) / 2 - <number>(<any>LinoHeightMaxPx) / 2)))}px`;
                pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
                pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
            }
        } else {
            linoLeft = r.renderStandardLino(filletCount, WoodFilletWidthPx, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, RailTopPx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, pcs);
        }
        // ep
        pcs.css.ep_visible = pcs.HasEngravedPlate;
        if (pcs.HasEngravedPlate) {
            let EPTopPx: number =
                <number>(RailSidePx + DocHeightPx + BevelWidthPx + SMatCount * (SMatWidthPx + BevelWidthPx) + filletCount * WoodFilletWidthPx) +
                <number>(
                    (<any>(
                        Math.floor(
                            (<number>(<any>RailSidePx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx)) - <number>(<any>filletCount) * <number>(<any>WoodFilletWidthPx)) / 2 -
                                (pcs.EPMethodID === EPMethod.Old ? <number>(<any>EPHeightPx) / 2 : 0),
                        )
                    ))
                ) -
                BevelWidthPx * 2;
            let EPLeftPx: number = <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>EPWidthPx) / 2)) - BevelWidthPx * 2;
            r.renderEngravedPlate(EPLeftPx, EPTopPx, EPWidthPx, EPHeightPx, BevelWidthPx, PMatWidthPx, pcs);
        }
        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Cameo)) {
            pcs.css.insignia_visible = false;
            pcs.css.cameo_visible = true;
            let CameoWidth: number = 4.75;
            let CameoHeight: number = 1.9;
            let CameoWidthPx: number = <number>(<any>Math.floor(CameoWidth * DPI)); // Cameo expands out to cover the missing inner accent space if no inner accent
            let CameoHeightPx: number = <number>(<any>Math.floor(CameoHeight * DPI));
            pcs.css.cameo_pmat_bevel_backgroundColor = `white`;
            pcs.css.cameo_pmat_bevel_left = `${(<number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>CameoWidthPx) / 2))).toString()}px`;
            pcs.css.cameo_pmat_bevel_top = `${(<number>(<any>Math.floor((<number>(<any>RailSidePx) - <number>(<any>BevelWidthPx) - SMatCount * (<number>(<any>SMatWidthPx) + BevelWidthPx)) / 2 - CameoHeightPx / 2)) - BevelWidthPx).toString()}px`;
            pcs.css.cameo_pmat_bevel_width = `${(CameoWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.cameo_pmat_bevel_height = `${(CameoHeightPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.cameo_pmat_bevel_borderRadius = `${CameoWidthPx.toString()}px / ${CameoHeightPx.toString()}px`;
            pcs.css.cameo_src = r.cameo_path(pcs.FramePartDomain, CameoWidthPx, pcs.Base_ExtraEntityName);
            pcs.css.cameo_left = `${BevelWidthPx.toString()}px`;
            pcs.css.cameo_top = `${BevelWidthPx.toString()}px`;
            pcs.css.cameo_width = `${CameoWidthPx.toString()}px`;
            pcs.css.cameo_height = `${CameoHeightPx.toString()}px`;
            pcs.css.cameo_borderRadius = `${CameoWidthPx.toString()}px / ${CameoHeightPx.toString()}px`;
        }

        if (pcs.ProductTypeID == 84) {
            insLeft = r.renderBottomInsignia(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, pcs);
            linoLeft = r.renderTopLino(filletCount, WoodFilletWidthPx, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, pcs);
        } else if (pcs.ProductTypeID == 69) {
            renderInsigniaOnBottomMoulding(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, MouldingWidthPx, pcs);
        } else if (pcs.ProductTypeID == 85 || pcs.ProductTypeID == 86) {
            renderLinoOnTopMoulding(filletCount, WoodFilletWidthPx, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, MouldingWidthPx, pcs);
        }

        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit) || pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
            pcs.css.spirit_visible = true;
            let left: number = <number>(<any>Math.floor(<number>(<any>(RailSidePx - SMatWidthPx - BevelWidthPx * 2)) / 2));
            let spirit_thick: number = <number>(<any>Math.floor(0.01260516605167 * <number>(<any>PMatWidthPx)));
            if (spirit_thick % 2 != 0) {
                spirit_thick += 1;
            }
            spirit_thick += 2;
            let spirit_smat_thick: number = <number>(<any>(<number>(<any>spirit_thick) / 2)) + 1;
            if (pcs.MaxFrameWidthPx >= 1280) {
                spirit_smat_thick = <number>(<any>(<number>(<any>spirit_thick) / 2)) - 1;
            }
            if (spirit_smat_thick % 2 != 0) {
                if (pcs.MaxFrameWidthPx <= 599 || pcs.MaxFrameWidthPx == 800) {
                    spirit_smat_thick -= 1;
                } else {
                    spirit_smat_thick += 1;
                }
            }
            pcs.css.spirit_smat_bg = `#${pcs.SecondaryMatColor}`;
            let smat_left: number = left + (spirit_thick - spirit_smat_thick) / 2;
            let sidesLeft: number = left - <number>(spirit_thick / 2);
            let sides_smat_Left: number = sidesLeft + <number>((spirit_thick - spirit_smat_thick) / 2);
            let sidesHeight: number = PMatHeightPx - left - left + spirit_thick;
            let smat_height: number = sidesHeight - (spirit_thick - spirit_smat_thick);
            // spirit widths
            pcs.css.spi_left_width = `${spirit_thick}px`;
            pcs.css.spi_right_width = `${spirit_thick}px`;
            pcs.css.spi_smat_left_width = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_right_width = `${spirit_smat_thick}px`;
            // spirit left and right
            pcs.css.spi_left_left = `${sidesLeft}px`;
            pcs.css.spi_right_right = `${sidesLeft}px`;
            pcs.css.spi_left_top = `${sidesLeft}px`;
            pcs.css.spi_right_top = `${sidesLeft}px`;
            pcs.css.spi_left_height = `${sidesHeight}px`;
            pcs.css.spi_right_height = `${sidesHeight}px`;
            // spirit smat left and right
            pcs.css.spi_smat_left_left = `${sides_smat_Left}px`;
            pcs.css.spi_smat_right_right = `${sides_smat_Left}px`;
            pcs.css.spi_smat_left_top = `${sides_smat_Left}px`;
            pcs.css.spi_smat_right_top = `${sides_smat_Left}px`;
            pcs.css.spi_smat_left_height = `${smat_height}px`;
            pcs.css.spi_smat_right_height = `${smat_height}px`;

            if (pcs.DYF_FrameStyleID === <number>(<any>DYF_FrameStylesEnum.Spirit)) {
                insLeft = r.renderBottomInsignia(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, pcs);
            }

            if (pcs.InsigniaPosition === InsigniaPositionEnum.Top) {
                insLeft = r.renderStandardInsignia(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, pcs);
            }

            pcs.css.spirit_visible_ins = insLeft > 0;
            pcs.css.spirit_ins_bot = pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit);
            pcs.css.spirit_visible_lino = pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB) && linoLeft > 0;
            // spirit bottom
            pcs.css.spi_bot1_left = `${left}px`;
            pcs.css.spi_bot2_right = `${left}px`;
            pcs.css.spi_bot1_bot = `${left - spirit_thick / 2}px`;
            pcs.css.spi_bot2_bot = `${left - spirit_thick / 2}px`;
            pcs.css.spi_smat_bot1_bot = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_smat_bot2_bot = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_bot1_height = `${spirit_thick}px`;
            pcs.css.spi_bot2_height = `${spirit_thick}px`;
            pcs.css.spi_smat_bot1_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_bot2_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_bot1_left = `${sides_smat_Left}px`;
            pcs.css.spi_smat_bot2_right = `${sides_smat_Left}px`;
            // bottom widths:
            if (pcs.InsigniaPosition !== undefined ? pcs.InsigniaPosition === InsigniaPositionEnum.Bottom : pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit)) {
                let _w: number = pcs.css.spirit_visible_ins ? insLeft - MaxInsigniaWidthPx : PMatWidthPx - left - left;
                pcs.css.spi_bot1_width = `${_w}px`;
                pcs.css.spi_bot2_width = `${_w}px`;
                pcs.css.spi_smat_bot1_width = `${_w}px`;
                pcs.css.spi_smat_bot2_width = `${_w}px`;
            } else if (pcs.InsigniaPosition !== undefined ? pcs.InsigniaPosition === InsigniaPositionEnum.Top : pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
                let _w: number = pcs.css.spirit_visible_lino ? linoLeft - <number>(<any>(<number>(<any>left) / 1.25)) : PMatWidthPx - left - left;
                pcs.css.spi_bot1_width = `${_w}px`;
                pcs.css.spi_bot2_width = `${_w}px`;
                pcs.css.spi_smat_bot1_width = `${_w}px`;
                pcs.css.spi_smat_bot2_width = `${_w}px`;
            }
            // spirit top
            pcs.css.spi_top1_left = `${left}px`;
            pcs.css.spi_top2_right = `${left}px`;
            pcs.css.spi_top1_top = `${left - spirit_thick / 2}px`;
            pcs.css.spi_top2_top = `${left - spirit_thick / 2}px`;
            pcs.css.spi_smat_top1_top = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_smat_top2_top = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_top1_height = `${spirit_thick}px`;
            pcs.css.spi_top2_height = `${spirit_thick}px`;
            pcs.css.spi_smat_top1_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_top2_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_top1_left = `${sides_smat_Left}px`;
            pcs.css.spi_smat_top2_right = `${sides_smat_Left}px`;
            // top widths:
            if (pcs.InsigniaPosition !== undefined ? pcs.InsigniaPosition === InsigniaPositionEnum.Bottom : pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit)) {
                let _w: number = PMatWidthPx - left - left;
                pcs.css.spi_top1_width = `${_w}px`;
                pcs.css.spi_top2_width = `${_w}px`;
                pcs.css.spi_smat_top1_width = `${_w}px`;
                pcs.css.spi_smat_top2_width = `${_w}px`;
                pcs.css.lino_visible = false;
            } else if (pcs.InsigniaPosition !== undefined ? pcs.InsigniaPosition === InsigniaPositionEnum.Top : pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
                let _w: number = pcs.css.spirit_visible_ins ? insLeft - MaxInsigniaWidthPx : PMatWidthPx - left - left;
                if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 1.9) {
                    let factor: number = 1;
                    if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 4.0) {
                        factor = 1.75;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 3.5) {
                        factor = 1.45;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 3.0) {
                        factor = 1.35;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.525) {
                        factor = 1.25;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches == 2.5) {
                        factor = 1.225;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.4) {
                        factor = 1.175;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.3) {
                        factor = 1.15;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.2) {
                        factor = 1.125;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.1) {
                        factor = 1.1;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.0) {
                        factor = 1.075;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 1.9) {
                        factor = 1.06;
                    }
                    if (pcs.Document_Width >= 14 || (pcs.Document_Height >= 11 && factor > 1)) {
                        factor = factor * 0.825;
                    }
                    let old_w: number = _w;
                    if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 1.9) {
                        _w = <number>(<any>(<number>(<number>(<any>insLeft) - <number>(<any>MaxInsigniaWidthPx)) * factor));
                    }
                    pcs.debug = `${pcs.Base_InsigniaWidthInches} - factor: ${factor} - old w: ${old_w} - new w: ${_w} - ww: ${pcs.Document_Width} - h: ${pcs.Document_Height}`;
                }
                pcs.css.spi_top1_width = `${_w}px`;
                pcs.css.spi_top2_width = `${_w}px`;
                pcs.css.spi_smat_top1_width = `${_w}px`;
                pcs.css.spi_smat_top2_width = `${_w}px`;
            }
        }
    };

    const renderSingleDynamic = (pcs: ProductCustomizationState, dynamicRailTop: number = 2.625, dynamicRailBottom: number = 2.625, dynamicRailSides: number = 2.625): void => {
        let CurrentDocWidth: number = 0;
        let CurrentDocHeight: number = 0;
        let DocSizeTier = r.getDocSizeTier(pcs);
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;

        if (pcs.Document_Width > WidthLimit) {
            let ratio: number = WidthLimit / pcs.Document_Width;
            pcs.Document_Width = WidthLimit;
            pcs.Document_Height = pcs.Document_Height * ratio;
        }
        if (pcs.Document_Height > HeightLimit) {
            let ratio: number = HeightLimit / pcs.Document_Height;
            pcs.Document_Height = HeightLimit;
            pcs.Document_Width = pcs.Document_Width * ratio;
        }
        CurrentDocWidth = pcs.Document_Width;
        CurrentDocHeight = pcs.Document_Height;

        let filletCount: number = pcs.MatCombo_IsWoodFillet ? 1 : 0;
        let SMatCount: number = !pcs.MatCombo_IsWoodFillet && pcs.SecondaryMatID > 0 ? 1 : 0;
        let SMatWidthPixelAdder: number = 1;

        // rail Setup
        // - Rail includes: Inner Mat and all mat bevels.
        // - The primary mat is actually the inner mat on single document frames
        // - The document "underlaps" the inner mat. See DocSizeTier.DocOverLap
        // - The mats are overlapped by the moulding by 0.25
        // - From this point forward, rail will be defined as all visible portions of mats including bevels (we are subtracting out the 0.25 of moulding overlap)
        let MouldingOverlap: number = 0.25;
        let RailTop: number = dynamicRailTop - MouldingOverlap;
        let RailSide: number = dynamicRailSides - MouldingOverlap;

        // Dim RailSize = CDec(DocSizeTier.CameoRail) - MouldingOverlap
        // insignia Adjustments
        let InsigniaWidth = pcs.Base_InsigniaWidthInches > 0 ? pcs.Base_InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
        // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '1: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit) || pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
            if (pcs.Base_InsigniaWidthInches > 1.9) {
            } else if (CurrentDocWidth < 10 && CurrentDocHeight < 10) {
                InsigniaWidth = Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.5);
                // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '2a: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
            } else if (CurrentDocWidth < 10 || CurrentDocHeight < 10) {
                InsigniaWidth = Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.4);
                // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '2b: {DefaultPCS.DefaultInsigniaWidthMax}:{RailTop}');"; data.fn.ExecuteSQL(sql); }
            }
        } else {
            InsigniaWidth = CurrentDocWidth < 10 && CurrentDocHeight < 10 ? Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.5) : InsigniaWidth;
            // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '2c: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
        }
        InsigniaWidth = DocSizeTier.DocSizeTierID >= 7 && pcs.Base_InsigniaWidthInches < 1 ? 2 : InsigniaWidth;
        // if (ProductID == 35808) { var sql = $"INSERT INTO BackendLogV2 VALUES (0, 18006, 138, GETUTCDATE(), 1, {ProductID}, 999, 999, 999, '34.192.96.123', '3: {InsigniaWidth}');"; data.fn.ExecuteSQL(sql); }
        // lino
        let LinoWidthMax: number = Math.min(DefaultPCS.DefaultLinoWidthMax, CurrentDocWidth + 1) + pcs.Base_LinoAdjustmentInches;
        LinoWidthMax = r.linoWidthAdjust(LinoWidthMax, pcs);
        let LinoHeightMax: number = DefaultPCS.DefaultLinoHeightMax * (LinoWidthMax / 11.5);
        // ****----____ EP-code-change ____----****
        let EPWidth: number = DefaultPCS.DefaultEPWidth;
        let EPHeight: number = DefaultPCS.DefaultEPHeight;
        if (CurrentDocHeight <= 7) {
            EPWidth = 3;
            EPHeight = 0.5;
        }
        // ****----____ EP-code-change ____----****
        let TotalWidth: number = RailSide * 2 + CurrentDocWidth + (pcs.UseMaxMouldingForSizing ? pcs.MouldingWidthMax * 2 : pcs.MouldingExtWidth * 2);
        let DPI: number = <number>(<any>Math.floor((pcs.MaxFrameWidthPx + 4) / TotalWidth)); // add 4. Yes, it's cheating, but we always round down and actually have a bit more room to work with.

        let done: boolean = false;
        let BevelWidthPx: number = -1;
        let DocWidthPx: number = -1;
        let DocHeightPx: number = -1;
        // ****----____ EP-code-change ____----****
        let EPWidthPx: number = -1;
        let EPHeightPx: number = -1;
        // ****----____ EP-code-change ____----****
        let MaxInsigniaWidthPx: number = -1;
        let LinoWidthMaxPx: number = -1;
        let LinoHeightMaxPx: number = -1;
        let MouldingWidthPx: number = -1;
        let MaxMouldingWidthPx: number = -1;
        let SMatWidthPx: number = -1;
        let RailSidePx: number = -1;

        let RailTopPx: number = -1;
        let RailBottomPx: number = -1;

        if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
            SMatWidthPx = 2;
        }
        let TotalUsedWidthPx: number = -1;
        let TotalUsedWidthPx_NoMargin: number = -1;
        let MaxSingleDocRailWidthPx: number = -1;
        let MaxPossibleSingleDocWidthPx: number = -1;
        let MaxPossibleSingleDocHeightPx: number = -1;
        let PMatWidthPx: number = -1;
        let TotalUsedHeightPx: number = -1;
        let TotalUsedHeightPx_NoMargin: number = 1;
        let PMatHeightPx: number = -1;
        let WoodFilletWidthPx: number = -1;

        while (!done) {
            BevelWidthPx = Math.max(1, <number>(<any>Math.round(pcs.BevelWidth * 2 * DPI))); // double bevel width. It was too small.
            DocWidthPx = <number>(<any>Math.round((CurrentDocWidth - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DocHeightPx = <number>(<any>Math.round((CurrentDocHeight - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            // ****----____ EP-code-change ____----****
            EPWidthPx = getEPWidth(pcs, DPI, EPWidth, DocWidthPx);
            EPHeightPx = getEPHeight(pcs, DPI, EPHeight, DocHeightPx);
            // ****----____ EP-code-change ____----****
            MaxInsigniaWidthPx = <number>(<any>Math.round(InsigniaWidth * DPI));
            LinoWidthMaxPx = <number>(<any>Math.round(LinoWidthMax * DPI));
            LinoHeightMaxPx = <number>(<any>Math.round(LinoHeightMax * DPI));
            MouldingWidthPx = <number>(<any>Math.round(pcs.MouldingExtWidth * DPI));
            MaxMouldingWidthPx = <number>(<any>Math.round(pcs.MouldingWidthMax * DPI));
            pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
            SMatWidthPx = Math.max(1, <number>(<any>Math.floor((pcs.InnerAccentWidth - pcs.BevelWidth) * DPI))) + SMatWidthPixelAdder; // innerAccentWidth includes bevel. We take bevel out here as we convert to pixels. Adding +1 pixel here. We might have to loop back and adjust DPI down
            RailSidePx = <number>(<any>Math.round(RailSide * DPI)) + SMatWidthPixelAdder * SMatCount + filletCount * (BevelWidthPx * 2 + SMatWidthPx); // we add the smat pixel adder because this adder is not accounted for in the core rail size specs. Also, if it is a wood fillet, we must add the wood fillet to the rail size since the fillet is additive

            RailTopPx = <number>(<any>Math.round(RailTop * DPI)) + SMatWidthPixelAdder * SMatCount + filletCount * (BevelWidthPx * 2 + SMatWidthPx);
            RailBottomPx = getRailBottomForDynamicEP(pcs, RailTopPx, EPHeightPx);

            if (pcs.ProductTypeID == 69 || pcs.ProductTypeID == 85 || pcs.ProductTypeID == 79 || pcs.ProductTypeID == 86) {
                RailSidePx = 0;
                RailTopPx = 0;
            }

            if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
                SMatWidthPx = 2;
            } // Cap SMat at 2px for images at or below 250px// Cap SMat at 2px for images at or below 250px
            TotalUsedWidthPx = RailSidePx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            TotalUsedWidthPx_NoMargin = RailSidePx * 2 + DocWidthPx + MouldingWidthPx * 2;
            // calculate the maximum possible width of a single doc frame with this document size. This is used to establish a common DPI across all single docs when UseCommonDPI is set to true
            MaxSingleDocRailWidthPx = Math.max(
                <number>(<any>Math.round((<number>(<any>DocSizeTier.CameoRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder,
                <number>(<any>Math.round((<number>(<any>DocSizeTier.StandardRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder + (BevelWidthPx * 2 + SMatWidthPx),
            ); // we use the larger cameo rail for this calculation. Also, compare against standard rail + fillet. Take the largest
            MaxPossibleSingleDocWidthPx = MaxSingleDocRailWidthPx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            MaxPossibleSingleDocHeightPx = MaxSingleDocRailWidthPx * 2 + DocHeightPx + MaxMouldingWidthPx * 2;
            PMatWidthPx = TotalUsedWidthPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side

            TotalUsedHeightPx = RailTopPx + RailBottomPx + DocHeightPx + MaxMouldingWidthPx * 2;
            TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + DocHeightPx + MouldingWidthPx * 2;

            PMatHeightPx = TotalUsedHeightPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            WoodFilletWidthPx = BevelWidthPx * 2 + SMatWidthPx;

            if (DocHeightPx > DocWidthPx && pcs.UseCommonDPI) {
                if (MaxPossibleSingleDocHeightPx > pcs.MaxFrameWidthPx) {
                    DPI -= 1;
                    done = false;
                } else {
                    done = true;
                }
            } else {
                if ((pcs.UseCommonDPI ? MaxPossibleSingleDocWidthPx : TotalUsedWidthPx_NoMargin) > pcs.MaxFrameWidthPx || (pcs.UseCommonDPI ? TotalUsedHeightPx : TotalUsedHeightPx_NoMargin) > pcs.MaxFrameHeightPx) {
                    DPI -= 1;
                    done = false;
                } else {
                    done = true;
                }
            }
        }

        // set DPI to a global object
        pcs.DPI = DPI;
        // check width, look back with new dpi if necessary
        pcs.FrameDisplay_width = TotalUsedWidthPx;
        pcs.FrameDisplay_height = TotalUsedHeightPx;
        // primary mat
        renderStandardPrimaryMat(pcs.FramePartDomain, PMatWidthPx, PMatHeightPx, MaxMouldingWidthPx, MouldingWidthPx, pcs);
        renderStandardMoulding(MouldingWidthPx, PMatWidthPx, PMatHeightPx, pcs);
        // secondary mat
        pcs.css.fillet_visible = filletCount > 0;
        if (SMatCount > 0) {
            // if there is an inner accent, then the outer mat "pulls back" to make room for the inner mat
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${DocWidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
            pcs.css.doc1_pmat_bevel_height = `${DocHeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
            // console.log(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx);
            r.RenderStandardSMat(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx, pcs);
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        } else if (filletCount > 0) {
            // turn off inner mat pieces
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `0px`;
            pcs.css.doc1_pmat_bevel_top = `0px`;
            pcs.css.doc1_pmat_bevel_width = ``;
            pcs.css.doc1_pmat_bevel_height = ``;
            r.renderCollapsedSMat(pcs);
            r.renderStandardFillet(RailSidePx, RailTopPx, WoodFilletWidthPx, DocWidthPx, DocHeightPx, pcs);
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${RailSidePx.toString()}px`;
            pcs.css.doc1_top = `${RailTopPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        } else {
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
            r.renderCollapsedSMat(pcs);
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        }
        // insignia
        let insLeft: number = r.renderStandardInsignia(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, pcs);
        // lino
        let linoLeft: number = -1;
        if (filletCount > 0) {
            pcs.css.lino_visible = pcs.Base_LinoID > 0;
            if (pcs.Base_LinoID != 0) {
                pcs.css.lino_src = r.lino_path(LinoWidthMaxPx, pcs);
                pcs.css.lino_left = `${<number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>LinoWidthMaxPx) / 2))}px`;
                pcs.css.lino_top = `${<number>(<any>(RailTopPx + DocHeightPx + filletCount * WoodFilletWidthPx + Math.floor((<number>(<any>RailSidePx) - <number>(<any>filletCount) * <number>(<any>WoodFilletWidthPx)) / 2 - <number>(<any>LinoHeightMaxPx) / 2)))}px`;
                pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
                pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
            }
        } else {
            linoLeft = r.renderStandardLino(filletCount, WoodFilletWidthPx, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, RailTopPx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, pcs);
        }
        // ep
        pcs.css.ep_visible = pcs.HasEngravedPlate;
        if (pcs.HasEngravedPlate) {
            let EPTopPx: number =
                <number>(RailSidePx + DocHeightPx + BevelWidthPx + SMatCount * (SMatWidthPx + BevelWidthPx) + filletCount * WoodFilletWidthPx) +
                <number>(<any>Math.floor((<number>(<any>RailSidePx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx)) - <number>(<any>filletCount) * <number>(<any>WoodFilletWidthPx)) / 2 - <number>(<any>EPHeightPx) / 2)) -
                BevelWidthPx * 2;
            let EPLeftPx: number = <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>EPWidthPx) / 2)) - BevelWidthPx * 2;
            r.renderEngravedPlate(EPLeftPx, EPTopPx, EPWidthPx, EPHeightPx, BevelWidthPx, PMatWidthPx, pcs);
        }
        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Cameo)) {
            pcs.css.insignia_visible = false;
            pcs.css.cameo_visible = true;
            let CameoWidth: number = 4.75;
            let CameoHeight: number = 1.9;
            let CameoWidthPx: number = <number>(<any>Math.floor(CameoWidth * DPI)); // Cameo expands out to cover the missing inner accent space if no inner accent
            let CameoHeightPx: number = <number>(<any>Math.floor(CameoHeight * DPI));
            pcs.css.cameo_pmat_bevel_backgroundColor = `white`;
            pcs.css.cameo_pmat_bevel_left = `${(<number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>CameoWidthPx) / 2))).toString()}px`;
            pcs.css.cameo_pmat_bevel_top = `${(<number>(<any>Math.floor((<number>(<any>RailSidePx) - <number>(<any>BevelWidthPx) - SMatCount * (<number>(<any>SMatWidthPx) + BevelWidthPx)) / 2 - CameoHeightPx / 2)) - BevelWidthPx).toString()}px`;
            pcs.css.cameo_pmat_bevel_width = `${(CameoWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.cameo_pmat_bevel_height = `${(CameoHeightPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.cameo_pmat_bevel_borderRadius = `${CameoWidthPx.toString()}px / ${CameoHeightPx.toString()}px`;
            pcs.css.cameo_src = r.cameo_path(pcs.FramePartDomain, CameoWidthPx, pcs.Base_ExtraEntityName);
            pcs.css.cameo_left = `${BevelWidthPx.toString()}px`;
            pcs.css.cameo_top = `${BevelWidthPx.toString()}px`;
            pcs.css.cameo_width = `${CameoWidthPx.toString()}px`;
            pcs.css.cameo_height = `${CameoHeightPx.toString()}px`;
            pcs.css.cameo_borderRadius = `${CameoWidthPx.toString()}px / ${CameoHeightPx.toString()}px`;
        }

        if (pcs.ProductTypeID == 84) {
            insLeft = r.renderBottomInsignia(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, pcs);
            linoLeft = r.renderTopLino(filletCount, WoodFilletWidthPx, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, pcs);
        } else if (pcs.ProductTypeID == 69) {
            r.renderInsigniaOnBottomMoulding(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, MouldingWidthPx, pcs);
        } else if (pcs.ProductTypeID == 85 || pcs.ProductTypeID == 86) {
            r.renderLinoOnTopMoulding(filletCount, WoodFilletWidthPx, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, MouldingWidthPx, pcs);

            console.log(pcs.css.lino_top);
        }

        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit) || pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
            pcs.css.spirit_visible = true;
            let left: number = <number>(<any>Math.floor(<number>(<any>(RailSidePx - SMatWidthPx - BevelWidthPx * 2)) / 2));
            let spirit_thick: number = <number>(<any>Math.floor(0.01260516605167 * <number>(<any>PMatWidthPx)));
            if (spirit_thick % 2 != 0) {
                spirit_thick += 1;
            }
            spirit_thick += 2;
            let spirit_smat_thick: number = <number>(<any>(<number>(<any>spirit_thick) / 2)) + 1;
            if (pcs.MaxFrameWidthPx >= 1280) {
                spirit_smat_thick = <number>(<any>(<number>(<any>spirit_thick) / 2)) - 1;
            }
            if (spirit_smat_thick % 2 != 0) {
                if (pcs.MaxFrameWidthPx <= 599 || pcs.MaxFrameWidthPx == 800) {
                    spirit_smat_thick -= 1;
                } else {
                    spirit_smat_thick += 1;
                }
            }
            pcs.css.spirit_smat_bg = `#${pcs.SecondaryMatColor}`;
            let smat_left: number = left + (spirit_thick - spirit_smat_thick) / 2;
            let sidesLeft: number = left - <number>(spirit_thick / 2);
            let sides_smat_Left: number = sidesLeft + <number>((spirit_thick - spirit_smat_thick) / 2);
            let sidesHeight: number = PMatHeightPx - left - left + spirit_thick;
            let smat_height: number = sidesHeight - (spirit_thick - spirit_smat_thick);
            // spirit widths
            pcs.css.spi_left_width = `${spirit_thick}px`;
            pcs.css.spi_right_width = `${spirit_thick}px`;
            pcs.css.spi_smat_left_width = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_right_width = `${spirit_smat_thick}px`;
            // spirit left and right
            pcs.css.spi_left_left = `${sidesLeft}px`;
            pcs.css.spi_right_right = `${sidesLeft}px`;
            pcs.css.spi_left_top = `${sidesLeft}px`;
            pcs.css.spi_right_top = `${sidesLeft}px`;
            pcs.css.spi_left_height = `${sidesHeight}px`;
            pcs.css.spi_right_height = `${sidesHeight}px`;
            // spirit smat left and right
            pcs.css.spi_smat_left_left = `${sides_smat_Left}px`;
            pcs.css.spi_smat_right_right = `${sides_smat_Left}px`;
            pcs.css.spi_smat_left_top = `${sides_smat_Left}px`;
            pcs.css.spi_smat_right_top = `${sides_smat_Left}px`;
            pcs.css.spi_smat_left_height = `${smat_height}px`;
            pcs.css.spi_smat_right_height = `${smat_height}px`;
            if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit)) {
                insLeft = r.renderBottomInsignia(filletCount, WoodFilletWidthPx, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, pcs);
            }
            pcs.css.spirit_visible_ins = insLeft > 0;
            pcs.css.spirit_ins_bot = pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit);
            pcs.css.spirit_visible_lino = pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB) && linoLeft > 0;
            // spirit bottom
            pcs.css.spi_bot1_left = `${left}px`;
            pcs.css.spi_bot2_right = `${left}px`;
            pcs.css.spi_bot1_bot = `${left - spirit_thick / 2}px`;
            pcs.css.spi_bot2_bot = `${left - spirit_thick / 2}px`;
            pcs.css.spi_smat_bot1_bot = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_smat_bot2_bot = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_bot1_height = `${spirit_thick}px`;
            pcs.css.spi_bot2_height = `${spirit_thick}px`;
            pcs.css.spi_smat_bot1_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_bot2_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_bot1_left = `${sides_smat_Left}px`;
            pcs.css.spi_smat_bot2_right = `${sides_smat_Left}px`;
            // bottom widths:
            if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit)) {
                let _w: number = pcs.css.spirit_visible_ins ? insLeft - MaxInsigniaWidthPx : PMatWidthPx - left - left;
                pcs.css.spi_bot1_width = `${_w}px`;
                pcs.css.spi_bot2_width = `${_w}px`;
                pcs.css.spi_smat_bot1_width = `${_w}px`;
                pcs.css.spi_smat_bot2_width = `${_w}px`;
            } else if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
                let _w: number = pcs.css.spirit_visible_lino ? linoLeft - <number>(<any>(<number>(<any>left) / 1.25)) : PMatWidthPx - left - left;
                pcs.css.spi_bot1_width = `${_w}px`;
                pcs.css.spi_bot2_width = `${_w}px`;
                pcs.css.spi_smat_bot1_width = `${_w}px`;
                pcs.css.spi_smat_bot2_width = `${_w}px`;
            }
            // spirit top
            pcs.css.spi_top1_left = `${left}px`;
            pcs.css.spi_top2_right = `${left}px`;
            pcs.css.spi_top1_top = `${left - spirit_thick / 2}px`;
            pcs.css.spi_top2_top = `${left - spirit_thick / 2}px`;
            pcs.css.spi_smat_top1_top = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_smat_top2_top = `${smat_left - spirit_thick / 2}px`;
            pcs.css.spi_top1_height = `${spirit_thick}px`;
            pcs.css.spi_top2_height = `${spirit_thick}px`;
            pcs.css.spi_smat_top1_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_top2_height = `${spirit_smat_thick}px`;
            pcs.css.spi_smat_top1_left = `${sides_smat_Left}px`;
            pcs.css.spi_smat_top2_right = `${sides_smat_Left}px`;
            // top widths:
            if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Spirit)) {
                let _w: number = PMatWidthPx - left - left;
                pcs.css.spi_top1_width = `${_w}px`;
                pcs.css.spi_top2_width = `${_w}px`;
                pcs.css.spi_smat_top1_width = `${_w}px`;
                pcs.css.spi_smat_top2_width = `${_w}px`;
                pcs.css.lino_visible = false;
            } else if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.SpiritB)) {
                let _w: number = pcs.css.spirit_visible_ins ? insLeft - MaxInsigniaWidthPx : PMatWidthPx - left - left;
                if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 1.9) {
                    let factor: number = 1;
                    if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 4.0) {
                        factor = 1.75;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 3.5) {
                        factor = 1.45;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 3.0) {
                        factor = 1.35;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.525) {
                        factor = 1.25;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches == 2.5) {
                        factor = 1.225;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.4) {
                        factor = 1.175;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.3) {
                        factor = 1.15;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.2) {
                        factor = 1.125;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.1) {
                        factor = 1.1;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 2.0) {
                        factor = 1.075;
                    } else if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 1.9) {
                        factor = 1.06;
                    }
                    if (pcs.Document_Width >= 14 || (pcs.Document_Height >= 11 && factor > 1)) {
                        factor = factor * 0.825;
                    }
                    let old_w: number = _w;
                    if (pcs.css.spirit_visible_ins && pcs.Base_InsigniaWidthInches >= 1.9) {
                        _w = <number>(<any>(<number>(<number>(<any>insLeft) - <number>(<any>MaxInsigniaWidthPx)) * factor));
                    }
                    pcs.debug = `${pcs.Base_InsigniaWidthInches} - factor: ${factor} - old w: ${old_w} - new w: ${_w} - ww: ${pcs.Document_Width} - h: ${pcs.Document_Height}`;
                }
                pcs.css.spi_top1_width = `${_w}px`;
                pcs.css.spi_top2_width = `${_w}px`;
                pcs.css.spi_smat_top1_width = `${_w}px`;
                pcs.css.spi_smat_top2_width = `${_w}px`;
            }
        }
    };

    const renderTasselFrame = (pcs: ProductCustomizationState): void => {
        let CurrentDocWidth: number = 0;
        let CurrentDocHeight: number = 0;
        let DocSizeTier = r.getDocSizeTier(pcs);
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;

        if (pcs.Document_Width > WidthLimit) {
            let ratio: number = WidthLimit / pcs.Document_Width;
            pcs.Document_Width = WidthLimit;
            pcs.Document_Height = pcs.Document_Height * ratio;
        }
        if (pcs.Document_Height > HeightLimit) {
            let ratio: number = HeightLimit / pcs.Document_Height;
            pcs.Document_Height = HeightLimit;
            pcs.Document_Width = pcs.Document_Width * ratio;
        }
        CurrentDocWidth = pcs.Document_Width;
        CurrentDocHeight = pcs.Document_Height;

        let filletCount: number = pcs.MatCombo_IsWoodFillet ? 1 : 0;

        let SMatCount: number = !pcs.MatCombo_IsWoodFillet && pcs.SecondaryMatID > 0 ? 1 : 0;
        let SMatWidthPixelAdder: number = 1;
        // rail Setup
        // - Rail includes: Inner Mat and all mat bevels.
        // - The primary mat is actually the inner mat on single document frames
        // - The document "underlaps" the inner mat. See DocSizeTier.DocOverLap
        // - The mats are overlapped by the moulding by 0.25
        // - From this point forward, rail will be defined as all visible portions of mats including bevels (we are subtracting out the 0.25 of moulding overlap)
        let MouldingOverlap: number = 0.25;
        let RailTop: number = <number>(<any>DocSizeTier.TasselRailHeight) - MouldingOverlap;
        let RailSide: number = <number>(<any>DocSizeTier.TasselRailWidth) - MouldingOverlap;
        // insignia Adjustments
        let InsigniaWidth = pcs.Base_InsigniaWidthInches > 0 ? pcs.Base_InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
        InsigniaWidth = CurrentDocWidth < 10 && CurrentDocHeight < 10 ? (InsigniaWidth = Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.5)) : InsigniaWidth;
        InsigniaWidth = DocSizeTier.DocSizeTierID >= 7 && pcs.Base_InsigniaWidthInches < 1 ? 2 : InsigniaWidth;
        // lino
        let LinoWidthMax: number = Math.min(DefaultPCS.DefaultLinoWidthMax, CurrentDocWidth + 1) + pcs.Base_LinoAdjustmentInches;
        LinoWidthMax = linoWidthAdjust(LinoWidthMax, pcs);
        let LinoHeightMax: number = DefaultPCS.DefaultLinoHeightMax * (LinoWidthMax / 11.5);
        // ****----____ EP-code-change ____----****
        let EPWidth: number = DefaultPCS.DefaultEPWidth;
        let EPHeight: number = DefaultPCS.DefaultEPHeight;
        if (CurrentDocHeight <= 7) {
            EPWidth = 3;
            EPHeight = 0.5;
        }
        // ****----____ EP-code-change ____----****
        let TotalWidth: number = RailSide * 2 + CurrentDocWidth + (pcs.UseMaxMouldingForSizing ? pcs.MouldingWidthMax * 2 : pcs.MouldingExtWidth * 2) + DocSizeTier.TasselGap + DocSizeTier.TasselWidth;
        let DPI: number = <number>(<any>Math.floor((pcs.MaxFrameWidthPx + 4) / TotalWidth)); // add 4. Yes, it's cheating, but we always round down and actually have a bit more room to work with.

        let done: boolean = false;
        let BevelWidthPx: number = -1;
        let DocWidthPx: number = -1;
        let DocHeightPx: number = -1;
        // ****----____ EP-code-change ____----****
        let EPWidthPx: number = -1;
        let EPHeightPx: number = -1;
        // ****----____ EP-code-change ____----****
        let MaxInsigniaWidthPx: number = -1;
        let LinoWidthMaxPx: number = -1;
        let LinoHeightMaxPx: number = -1;
        let MouldingWidthPx: number = -1;
        let MaxMouldingWidthPx: number = -1;
        pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
        let RailSidePx: number = -1;
        let RailTopPx: number = -1;
        let RailBottomPx: number = -1;
        let SMatWidthPx: number = -1;
        if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
            SMatWidthPx = 2;
        } // cap SMat at 2px for images at or below 250px// cap SMat at 2px for images at or below 250px
        let TasselGapPx: number = -1;
        let TasselWidthPx: number = -1;
        let TasselHeightPx: number = -1;
        let TotalUsedWidthPx: number = -1;
        let TotalUsedWidthPx_NoMargin: number = -1;
        let PMatWidthPx: number = -1;
        let TotalUsedHeightPx: number = -1;
        let TotalUsedHeightPx_NoMargin: number = -1;
        let PMatHeightPx: number = -1;

        while (!done) {
            BevelWidthPx = Math.max(1, <number>(<any>Math.round(pcs.BevelWidth * 2 * DPI))); // double bevel width. It was too small.
            DocWidthPx = <number>(<any>Math.round((CurrentDocWidth - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DocHeightPx = <number>(<any>Math.round((CurrentDocHeight - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            // ****----____ EP-code-change ____----****
            EPWidthPx = getEPWidth(pcs, DPI, EPWidth, DocWidthPx);
            EPHeightPx = getEPHeight(pcs, DPI, EPHeight, DocHeightPx);
            // ****----____ EP-code-change ____----****
            MaxInsigniaWidthPx = <number>(<any>Math.round(InsigniaWidth * DPI));
            LinoWidthMaxPx = <number>(<any>Math.round(LinoWidthMax * DPI));
            LinoHeightMaxPx = <number>(<any>Math.round(LinoHeightMax * DPI));
            MouldingWidthPx = <number>(<any>Math.round(pcs.MouldingExtWidth * DPI));
            MaxMouldingWidthPx = <number>(<any>Math.round(pcs.MouldingWidthMax * DPI));
            pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
            RailSidePx = <number>(<any>Math.round(RailSide * DPI)) + SMatWidthPixelAdder * SMatCount; // we add the smat pixel adder because this adder is not accounted for in the core rail size specs
            RailTopPx = <number>(<any>Math.round(RailTop * DPI)) + SMatWidthPixelAdder * SMatCount;
            RailBottomPx = getRailBottomForDynamicEP(pcs, RailTopPx, EPHeightPx);
            SMatWidthPx = Math.max(1, <number>(<any>Math.floor((pcs.InnerAccentWidth - pcs.BevelWidth) * DPI))) + SMatWidthPixelAdder; // innerAccentWidth includes bevel. We take bevel out here as we convert to pixels.
            if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
                SMatWidthPx = 2;
            } // cap SMat at 2px for images at or below 250px// cap SMat at 2px for images at or below 250px
            TasselGapPx = <number>(<any>Math.round(DocSizeTier.TasselGap * DPI)) + SMatWidthPixelAdder * SMatCount * 2;
            TasselWidthPx = <number>(<any>Math.round(DocSizeTier.TasselWidth * DPI)) + SMatWidthPixelAdder * SMatCount; // tassel expands out to cover the missing inner accent space if no inner accent
            TasselHeightPx = <number>(<any>Math.round(DocSizeTier.TasselHeight * DPI)) + SMatWidthPixelAdder * SMatCount; // we add the smat pixel adder because this adder is not accounted for in the core rail size specs
            TotalUsedWidthPx = RailSidePx * 2 + DocWidthPx + MaxMouldingWidthPx * 2 + TasselGapPx + TasselWidthPx;
            TotalUsedWidthPx_NoMargin = RailSidePx * 2 + DocWidthPx + MouldingWidthPx * 2 + TasselGapPx + TasselWidthPx;
            PMatWidthPx = TotalUsedWidthPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            TotalUsedHeightPx = RailTopPx + RailBottomPx + DocHeightPx + MaxMouldingWidthPx * 2;
            TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + DocHeightPx + MouldingWidthPx * 2;
            PMatHeightPx = TotalUsedHeightPx - MaxMouldingWidthPx * 2; // refers to the outer width, not

            if (TotalUsedWidthPx_NoMargin > pcs.MaxFrameWidthPx || TotalUsedHeightPx_NoMargin > pcs.MaxFrameHeightPx) {
                DPI -= 1;
            } else {
                done = true;
            }
        }

        // set DPI to a global object
        pcs.DPI = DPI;
        // check width, look back with new dpi if necessary
        pcs.FrameDisplay_width = TotalUsedWidthPx;
        pcs.FrameDisplay_height = TotalUsedHeightPx;
        // primary mat
        r.renderStandardPrimaryMat(pcs.FramePartDomain, PMatWidthPx, PMatHeightPx, MaxMouldingWidthPx, MouldingWidthPx, pcs);
        r.renderStandardMoulding(MouldingWidthPx, PMatWidthPx, PMatHeightPx, pcs);
        pcs.css.tassel_visible = true;
        // if there is an inner accent, then the outer mat "pulls back" to make room for the inner mat
        if (SMatCount > 0) {
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${DocWidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
            pcs.css.doc1_pmat_bevel_height = `${DocHeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
            r.RenderStandardSMat(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx, pcs);
            pcs.css.tassel_pmat_bevel_backgroundColor = `white`;
            pcs.css.tassel_pmat_bevel_left = `${(RailSidePx + DocWidthPx + TasselGapPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.tassel_pmat_bevel_top = `${(<number>(<any>Math.floor((<number>(<any>PMatHeightPx) - <number>(<any>TasselHeightPx) - <number>(<any>SMatWidthPx) * 2 - <number>(<any>BevelWidthPx) * 4) / 2))).toString()}px`;
            pcs.css.tassel_pmat_bevel_width = `${(TasselWidthPx + SMatWidthPx * 2 + BevelWidthPx * 4).toString()}px`;
            pcs.css.tassel_pmat_bevel_height = `${(TasselHeightPx + SMatWidthPx * 2 + BevelWidthPx * 4).toString()}px`;
            pcs.css.tassel_smat_backgroundColor = `#${pcs.SecondaryMatColor}`;
            pcs.css.tassel_smat_left = `${BevelWidthPx.toString()}px`;
            pcs.css.tassel_smat_top = `${BevelWidthPx.toString()}px`;
            pcs.css.tassel_smat_width = `${(TasselWidthPx + 2 * (BevelWidthPx + SMatWidthPx)).toString()}px`;
            pcs.css.tassel_smat_height = `${(TasselHeightPx + 2 * (BevelWidthPx + SMatWidthPx)).toString()}px`;
            pcs.css.tassel_smat_bevel_backgroundColor = `white`;
            pcs.css.tassel_smat_bevel_left = `${SMatWidthPx.toString()}px`;
            pcs.css.tassel_smat_bevel_top = `${SMatWidthPx.toString()}px`;
            pcs.css.tassel_smat_bevel_width = `${(TasselWidthPx + 2 * BevelWidthPx).toString()}px`;
            pcs.css.tassel_smat_bevel_height = `${(TasselHeightPx + 2 * BevelWidthPx).toString()}px`;
        } else {
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.tassel_pmat_bevel_backgroundColor = `white`;
            pcs.css.tassel_pmat_bevel_left = `${(RailSidePx + DocWidthPx + TasselGapPx - BevelWidthPx).toString()}px`;
            pcs.css.tassel_pmat_bevel_top = `${(<number>(<any>Math.floor((<number>(<any>PMatHeightPx) - <number>(<any>TasselHeightPx)) / 2))).toString()}px`;
            pcs.css.tassel_pmat_bevel_width = `${(TasselWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.tassel_pmat_bevel_height = `${(TasselHeightPx + BevelWidthPx * 2).toString()}px`;
            r.renderCollapsedSMat(pcs);
            pcs.css.tassel_smat_backgroundColor = `none`;
            pcs.css.tassel_smat_left = `0px`;
            pcs.css.tassel_smat_top = `0px`;
            pcs.css.tassel_smat_width = ``;
            pcs.css.tassel_smat_height = ``;
            pcs.css.tassel_smat_bevel_backgroundColor = `none`;
            pcs.css.tassel_smat_bevel_left = `0px`;
            pcs.css.tassel_smat_bevel_top = `0px`;
            pcs.css.tassel_smat_bevel_width = ``;
            pcs.css.tassel_smat_bevel_height = ``;
        }
        pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
        pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
        pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
        pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
        pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        pcs.css.tassel_src = r.tassel_path(pcs.CDNDomain, TasselWidthPx, pcs.Base_ExtraEntityName);
        pcs.css.tassel_left = `${BevelWidthPx.toString()}px`;
        pcs.css.tassel_top = `${BevelWidthPx.toString()}px`;
        pcs.css.tassel_width = `${TasselWidthPx.toString()}px`;
        pcs.css.tassel_height = `${TasselHeightPx.toString()}px`;
        pcs.css.insignia_visible = pcs.Base_InsigniaID > 0;
        if (pcs.Base_InsigniaID > 0) {
            pcs.css.insignia_src = r.insignia_path(pcs.FramePartDomain, MaxInsigniaWidthPx, pcs.Base_InsigniaName);
            pcs.css.insignia_left = `${<number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))}px`;
            pcs.css.insignia_top = `${<number>(<any>Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))}px`;
            pcs.css.insignia_width = `${MaxInsigniaWidthPx.toString()}px`;
            pcs.css.insignia_height = `${MaxInsigniaWidthPx.toString()}px`;
        }
        pcs.css.lino_visible = pcs.Base_LinoID > 0;
        if (pcs.Base_LinoID > 0) {
            pcs.css.lino_src = r.lino_path(LinoWidthMaxPx, pcs);
            pcs.css.lino_left = `${<number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>LinoWidthMaxPx) / 2))}px`;
            pcs.css.lino_top = `${<number>(<any>(RailTopPx + DocHeightPx + BevelWidthPx + SMatCount * (SMatWidthPx + BevelWidthPx) + Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>LinoHeightMaxPx) / 2)))}px`;
            pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
            pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
        }
        // ep
        pcs.css.ep_visible = pcs.HasEngravedPlate;
        if (pcs.HasEngravedPlate) {
            let EPTopPx: number =
                <number>(
                    (<any>(
                        (RailTopPx +
                            DocHeightPx +
                            BevelWidthPx +
                            SMatCount * (SMatWidthPx + BevelWidthPx) +
                            Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>EPHeightPx) / 2))
                    ))
                ) -
                BevelWidthPx * 2;
            let EPLeftPx: number = <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>EPWidthPx) / 2)) - BevelWidthPx * 2;
            r.renderEngravedPlate(EPLeftPx, EPTopPx, EPWidthPx, EPHeightPx, BevelWidthPx, PMatWidthPx, pcs);
        }
    };

    const renderDoubleDoc = (pcs: ProductCustomizationState): void => {
        let DoubleDocSeparation: number = 1.35;
        let SMatCount: number = !pcs.MatCombo_IsWoodFillet && pcs.SecondaryMatID > 0 ? 1 : 0;
        let SMatWidthPixelAdder: number = 1;
        let CurrentDocWidth: number = 0;
        let CurrentDocHeight: number = 0;
        let CurrentDoc2Width: number = 0;
        let CurrentDoc2Height: number = 0;
        let DocSizeTier1 = r.getDocSizeTier(pcs);
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;

        CurrentDocWidth = pcs.Document_Width;
        CurrentDocHeight = pcs.Document_Height;

        if (pcs.Document_Width > WidthLimit) {
            let ratio: number = WidthLimit / pcs.Document_Width;
            CurrentDocWidth = WidthLimit;
            CurrentDocHeight = pcs.Document_Height * ratio;
        }
        if (pcs.Document_Height > HeightLimit) {
            let ratio: number = HeightLimit / pcs.Document_Height;
            CurrentDocHeight = HeightLimit;
            CurrentDocWidth = pcs.Document_Width * ratio;
        }

        let Temp_Doc_Width2: number = 0;
        let Temp_Doc_Height2: number = 0;

        pcs.Document2_Width = pcs.Document2_Width <= 0 ? pcs.Document_Width : pcs.Document2_Width;
        pcs.Document2_Height = pcs.Document2_Height <= 0 ? pcs.Document_Height : pcs.Document2_Height;

        // we need to scale the second document if we ended up with adjusted doc 1 dimensions
        Temp_Doc_Width2 = pcs.Document2_Width <= 0 ? pcs.Document_Width : pcs.Document2_Width; // fall back to doc 1 dimensions if do 2 dimensions are undefined
        Temp_Doc_Height2 = pcs.Document2_Height <= 0 ? pcs.Document_Height : pcs.Document2_Height;
        if (CurrentDocWidth < pcs.Document_Width) {
            Temp_Doc_Width2 = (CurrentDocWidth / pcs.Document_Width) * Temp_Doc_Width2;
            Temp_Doc_Height2 = (CurrentDocHeight / pcs.Document_Height) * Temp_Doc_Height2;
        }

        pcs.Document2_Width = Temp_Doc_Width2;
        pcs.Document2_Height = Temp_Doc_Height2;

        let DocSizeTier2 = r.getDocSizeTier2(pcs);
        CurrentDoc2Width = pcs.Document2_Width;
        CurrentDoc2Height = pcs.Document2_Height;

        // we need to scale the first document if we ended up with adjusted doc 2 dimensions
        if (CurrentDoc2Width < Temp_Doc_Width2 - 0.001) {
            // use a buffer here.
            CurrentDocWidth = (CurrentDoc2Width / pcs.Document2_Width) * CurrentDocWidth;
            CurrentDocHeight = (CurrentDoc2Height / pcs.Document2_Height) * CurrentDocHeight;
        }

        let doCampusAlternate = false;
        let CampusVertical = false;
        let original_vertical = !pcs.isHorizontal;
        if (pcs.ProductTypeID === 8 || pcs.ProductTypeID === 9) {
            if (pcs.Base_ExtraHeight > 756) {
                doCampusAlternate = true;
                var reduction_ratio = 756 / pcs.Base_ExtraHeight;
                pcs.isHorizontal = false;
                CurrentDoc2Height = CurrentDocHeight;
                CurrentDoc2Width = CurrentDocHeight * reduction_ratio;

                var w1 = CurrentDocWidth;
                var h1 = CurrentDocHeight;
                var w2 = CurrentDoc2Width;
                var h2 = CurrentDoc2Height;

                CurrentDocWidth = w2;
                CurrentDocHeight = h2;
                CurrentDoc2Width = w1;
                CurrentDoc2Height = h1;
            } else {
                doCampusAlternate = false;
                var campus_ratio = 1;
                if (!pcs.isHorizontal) {
                    pcs.isHorizontal = true;
                    CurrentDoc2Width = CurrentDoc2Height;
                    CurrentDoc2Height = CurrentDoc2Width;
                    CampusVertical = true;
                }

                if (pcs.Base_ExtraHeight < 32) {
                    //console.log('1');
                    campus_ratio = 1;
                } else if (pcs.Base_ExtraHeight > 32 && pcs.Base_ExtraHeight != 580) {
                    //console.log('2');
                    var new1 = pcs.Base_ExtraHeight;
                    var new2 = 580;
                    campus_ratio = new1 / new2;
                } else {
                    //console.log('3');
                    campus_ratio = 1;
                }

                if (campus_ratio != 1 && CampusVertical) {
                    CurrentDoc2Height = CurrentDocWidth * (pcs.Base_ExtraHeight / 756);
                    CurrentDoc2Width = CurrentDocWidth;
                } else if (campus_ratio !== 1) {
                    //console.log('4');
                    CurrentDoc2Height = CurrentDoc2Height * campus_ratio;
                }
            }

            // console.log(pcs.DocumentID);
            // console.log(pcs.DocumentID2);
            // console.log(pcs.Base_DocumentName);
            // console.log(pcs.Base_DocumentName2);
        }

        let DocSizeTier = DocSizeTier1.DocSizeTierID >= DocSizeTier2.DocSizeTierID ? DocSizeTier1 : DocSizeTier2;

        // console.log('----');
        // console.log(CurrentDocWidth);
        // console.log(CurrentDocHeight);
        // console.log(CurrentDoc2Width);
        // console.log(CurrentDoc2Height);

        // rail Setup
        // - Rail includes: Inner Mat and all mat bevels.
        // - The primary mat is actually the inner mat on single document frames
        // - The document "underlaps" the inner mat. See DocSizeTier.DocOverLap
        // - The mats are overlapped by the moulding by 0.25
        // - From this point forward, rail will be defined as all visible portions of mats including bevels (we are subtracting out the 0.25 of moulding overlap)
        let MouldingOverlap: number = 0.25;
        let RailTop: number = <number>(<any>DocSizeTier.StandardRail) - MouldingOverlap;
        let RailSide: number = <number>(<any>DocSizeTier.StandardRail) - MouldingOverlap;
        // insignia Adjustments
        let InsigniaWidth = pcs.Base_InsigniaWidthInches > 0 ? pcs.Base_InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
        InsigniaWidth = CurrentDocWidth < 10 && CurrentDocHeight < 10 ? (InsigniaWidth = Math.min(DefaultPCS.DefaultInsigniaWidthMax, RailTop - 0.5)) : InsigniaWidth;
        InsigniaWidth = DocSizeTier.DocSizeTierID >= 7 && pcs.Base_InsigniaWidthInches <= 0 ? 2 : InsigniaWidth;
        // lino
        let LinoWidthMax: number = Math.min(DefaultPCS.DefaultLinoWidthMax, CurrentDocWidth + 1) + pcs.Base_LinoAdjustmentInches;
        if (doCampusAlternate) {
            LinoWidthMax = Math.min(DefaultPCS.DefaultLinoWidthMax, CurrentDoc2Width + 1) + pcs.Base_LinoAdjustmentInches;
        }
        LinoWidthMax = r.linoWidthAdjust(LinoWidthMax, pcs);
        let LinoHeightMax: number = DefaultPCS.DefaultLinoHeightMax * (LinoWidthMax / 11.5);

        // ****----____ EP-code-change ____----****
        let EPWidth: number = DefaultPCS.DefaultEPWidth;
        let EPHeight: number = DefaultPCS.DefaultEPHeight;
        if (CurrentDocHeight <= 7) {
            EPWidth = 3;
            EPHeight = 0.5;
        }

        // ****----____ EP-code-change ____----****
        let TotalWidth: number = RailSide * 2 + Math.max(CurrentDocWidth, CurrentDoc2Width) + (pcs.UseMaxMouldingForSizing ? pcs.MouldingWidthMax * 2 : pcs.MouldingExtWidth * 2);
        let DPI: number = <number>(<any>Math.floor((pcs.MaxFrameWidthPx + 4) / TotalWidth)); // add 4. Yes, it's cheating, but we always round down and actually have a bit more room to work with.
        let done: boolean = false;
        let doneCount: number = 0;
        let BevelWidthPx: number = -1;
        let DocWidthPx: number = -1;
        let DocHeightPx: number = -1;
        let Doc2WidthPx: number = -1;
        let Doc2HeightPx: number = -1;
        let DoubleDocSeparationPx: number = -1;
        let EPWidthPx: number = -1;
        let EPHeightPx: number = -1;
        let MaxInsigniaWidthPx: number = -1;
        let LinoWidthMaxPx: number = -1;
        let LinoHeightMaxPx: number = -1;
        let MouldingWidthPx: number = -1;
        let MaxMouldingWidthPx: number = -1;
        let RailSidePx: number = -1;
        let RailTopPx: number = -1;
        let RailBottomPx: number = -1;
        let SMatWidthPx: number = -1;
        let TotalUsedWidthPx: number = 0;
        let TotalUsedWidthPx_NoMargin: number = 0;
        let TotalUsedHeightPx: number = 0;
        let TotalUsedHeightPx_NoMargin: number = 0;
        let PMatWidthPx: number = -1;
        let PMatHeightPx: number = -1;
        while (!done) {
            doneCount += 1;
            BevelWidthPx = Math.max(1, <number>(<any>Math.round(pcs.BevelWidth * 2 * DPI))); // double bevel width. It was too small.
            DocWidthPx = <number>(<any>Math.round((CurrentDocWidth - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DocHeightPx = <number>(<any>Math.round((CurrentDocHeight - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            Doc2WidthPx = <number>(<any>Math.round((CurrentDoc2Width - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            Doc2HeightPx = <number>(<any>Math.round((CurrentDoc2Height - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DoubleDocSeparationPx = <number>(<any>Math.round(DoubleDocSeparation * DPI)) + SMatWidthPixelAdder * SMatCount * 2; // we add the smat pixel adder because this adder is not accounted for in the core doc separation specs
            // ****----____ EP-code-change ____----****
            EPWidthPx = getEPWidth(pcs, DPI, EPWidth, DocWidthPx);
            EPHeightPx = getEPHeight(pcs, DPI, EPHeight, DocHeightPx);
            // ****----____ EP-code-change ____----****
            MaxInsigniaWidthPx = <number>(<any>Math.round(InsigniaWidth * DPI));
            LinoWidthMaxPx = <number>(<any>Math.round(LinoWidthMax * DPI));
            LinoHeightMaxPx = <number>(<any>Math.round(LinoHeightMax * DPI));
            MouldingWidthPx = <number>(<any>Math.round(pcs.MouldingExtWidth * DPI));
            MaxMouldingWidthPx = <number>(<any>Math.round(pcs.MouldingWidthMax * DPI));
            pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
            RailSidePx = <number>(<any>Math.round(RailSide * DPI)) + SMatWidthPixelAdder * SMatCount; // we add the smat pixel adder because this adder is not accounted for in the core rail size specs
            RailTopPx = <number>(<any>Math.round(RailTop * DPI)) + SMatWidthPixelAdder * SMatCount;
            RailBottomPx = getRailBottomForDynamicEP(pcs, RailTopPx, EPHeightPx);
            SMatWidthPx = Math.max(1, <number>(<any>Math.floor((pcs.InnerAccentWidth - pcs.BevelWidth) * DPI))) + SMatWidthPixelAdder; // innerAccentWidth includes bevel. We take bevel out here as we convert to pixels.
            if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
                SMatWidthPx = 2;
            } // Cap SMat at 2px for images at or below 250px// Cap SMat at 2px for images at or below 250px
            TotalUsedWidthPx = 0;
            TotalUsedWidthPx_NoMargin = 0;
            TotalUsedHeightPx = 0;
            TotalUsedHeightPx_NoMargin = 0;
            if (pcs.isHorizontal) {
                TotalUsedWidthPx = RailSidePx * 2 + Math.max(DocWidthPx, Doc2WidthPx) + MaxMouldingWidthPx * 2;
                TotalUsedWidthPx_NoMargin = RailSidePx * 2 + Math.max(DocWidthPx, Doc2WidthPx) + MouldingWidthPx * 2;
                TotalUsedHeightPx = RailTopPx + RailBottomPx + DocHeightPx + Doc2HeightPx + DoubleDocSeparationPx + MaxMouldingWidthPx * 2;
                TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + DocHeightPx + Doc2HeightPx + DoubleDocSeparationPx + MouldingWidthPx * 2;
            } else {
                TotalUsedWidthPx = RailSidePx * 2 + DocWidthPx + Doc2WidthPx + DoubleDocSeparationPx + MaxMouldingWidthPx * 2;
                TotalUsedWidthPx_NoMargin = RailSidePx * 2 + DocWidthPx + Doc2WidthPx + DoubleDocSeparationPx + MouldingWidthPx * 2;
                TotalUsedHeightPx = RailTopPx + RailBottomPx + Math.max(DocHeightPx, Doc2HeightPx) + MaxMouldingWidthPx * 2;
                TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + Math.max(DocHeightPx, Doc2HeightPx) + MouldingWidthPx * 2;
            }
            // calculate the maximum possible width of a single doc frame with this document size. This is used to establish a common DPI across all single docs when UseCommonDPI is set to true
            PMatWidthPx = TotalUsedWidthPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            PMatHeightPx = TotalUsedHeightPx - MaxMouldingWidthPx * 2;
            // if UseCommonDPI is turned on, we want to sync single doc, cameo, and spirit. We sync them in such a way that, if turned on their side, vertical frames will still fit.
            if (DocHeightPx > DocWidthPx && pcs.UseCommonDPI) {
                if (TotalUsedHeightPx > pcs.MaxFrameWidthPx || TotalUsedWidthPx > pcs.MaxFrameWidthPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            } else {
                if ((pcs.UseCommonDPI ? TotalUsedWidthPx : TotalUsedWidthPx_NoMargin) > pcs.MaxFrameWidthPx || (pcs.UseCommonDPI ? TotalUsedHeightPx : TotalUsedHeightPx_NoMargin) > pcs.MaxFrameHeightPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            }
            if (doneCount > 100000) {
                done = true;
            }
        }

        // set DPI to a global object
        pcs.DPI = DPI;
        // check width, look back with new dpi if necessary
        pcs.FrameDisplay_width = TotalUsedWidthPx;
        pcs.FrameDisplay_height = TotalUsedHeightPx;
        // primary mat
        r.renderStandardPrimaryMat(pcs.FramePartDomain, PMatWidthPx, PMatHeightPx, MaxMouldingWidthPx, MouldingWidthPx, pcs);
        r.renderStandardMoulding(MouldingWidthPx, PMatWidthPx, PMatHeightPx, pcs);
        if (SMatCount > 0) {
            if (pcs.isHorizontal) {
                // if there is an inner accent, then the outer mat "pulls back" to make room for the inner mat
                pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc1_pmat_bevel_left = `${(RailSidePx + ((PMatWidthPx - 2 * RailSidePx) / 2 - DocWidthPx / 2) - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc1_pmat_bevel_width = `${DocWidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
                pcs.css.doc1_pmat_bevel_height = `${DocHeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
                pcs.css.doc2_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc2_pmat_bevel_left = `${(RailSidePx + ((PMatWidthPx - 2 * RailSidePx) / 2 - Doc2WidthPx / 2) - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_pmat_bevel_top = `${(RailTopPx + DocHeightPx + DoubleDocSeparationPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_pmat_bevel_width = `${Doc2WidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
                pcs.css.doc2_pmat_bevel_height = `${Doc2HeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
                r.RenderStandardSMat(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx, pcs);
                pcs.css.doc2_smat_backgroundColor = `#${pcs.SecondaryMatColor}`;
                pcs.css.doc2_smat_left = `${BevelWidthPx.toString()}px`;
                pcs.css.doc2_smat_top = `${BevelWidthPx.toString()}px`;
                pcs.css.doc2_smat_width = `${(Doc2WidthPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_smat_height = `${(Doc2HeightPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_smat_bevel_backgroundColor = `white`;
                pcs.css.doc2_smat_bevel_left = `${SMatWidthPx.toString()}px`;
                pcs.css.doc2_smat_bevel_top = `${SMatWidthPx.toString()}px`;
                pcs.css.doc2_smat_bevel_width = `${(Doc2WidthPx + BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_smat_bevel_height = `${(Doc2HeightPx + BevelWidthPx * 2).toString()}px`;
            } else {
                pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc1_pmat_bevel_top = `${(RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - DocHeightPx / 2) - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc1_pmat_bevel_width = `${(DocWidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)).toString()}px`;
                pcs.css.doc1_pmat_bevel_height = `${(DocHeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)).toString()}px`;
                pcs.css.doc2_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc2_pmat_bevel_left = `${(RailSidePx + DocWidthPx + DoubleDocSeparationPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_pmat_bevel_top = `${(RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - Doc2HeightPx / 2) - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_pmat_bevel_width = `${(Doc2WidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)).toString()}px`;
                pcs.css.doc2_pmat_bevel_height = `${(Doc2HeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)).toString()}px`;
                r.RenderStandardSMat(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx, pcs);
                pcs.css.doc2_smat_backgroundColor = `#${pcs.SecondaryMatColor}`;
                pcs.css.doc2_smat_left = `${BevelWidthPx.toString()}px`;
                pcs.css.doc2_smat_top = `${BevelWidthPx.toString()}px`;
                pcs.css.doc2_smat_width = `${(Doc2WidthPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_smat_height = `${(Doc2HeightPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_smat_bevel_backgroundColor = `white`;
                pcs.css.doc2_smat_bevel_left = `${SMatWidthPx.toString()}px`;
                pcs.css.doc2_smat_bevel_top = `${SMatWidthPx.toString()}px`;
                pcs.css.doc2_smat_bevel_width = `${(Doc2WidthPx + BevelWidthPx * 2).toString()}px`;
                pcs.css.doc2_smat_bevel_height = `${(Doc2HeightPx + BevelWidthPx * 2).toString()}px`;
            }
        } else {
            if (pcs.isHorizontal) {
                pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc1_pmat_bevel_left = `${RailSidePx + ((PMatWidthPx - 2 * RailSidePx) / 2 - DocWidthPx / 2) - BevelWidthPx}px`;
                pcs.css.doc1_pmat_bevel_top = `${RailTopPx - BevelWidthPx}px`;
                pcs.css.doc1_pmat_bevel_width = `${DocWidthPx + BevelWidthPx * 2}px`;
                pcs.css.doc1_pmat_bevel_height = `${DocHeightPx + BevelWidthPx * 2}px`;
                pcs.css.doc2_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc2_pmat_bevel_left = `${RailSidePx + ((PMatWidthPx - 2 * RailSidePx) / 2 - Doc2WidthPx / 2) - BevelWidthPx}px`;
                pcs.css.doc2_pmat_bevel_top = `${RailTopPx + DocHeightPx + DoubleDocSeparationPx - BevelWidthPx}px`;
                pcs.css.doc2_pmat_bevel_width = `${Doc2WidthPx + BevelWidthPx * 2}px`;
                pcs.css.doc2_pmat_bevel_height = `${Doc2HeightPx + BevelWidthPx * 2}px`;
            } else {
                pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc1_pmat_bevel_left = `${RailSidePx - BevelWidthPx}px`;
                pcs.css.doc1_pmat_bevel_top = `${RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - DocHeightPx / 2) - BevelWidthPx}px`;
                pcs.css.doc1_pmat_bevel_width = `${DocWidthPx + BevelWidthPx * 2}px`;
                pcs.css.doc1_pmat_bevel_height = `${DocHeightPx + BevelWidthPx * 2}px`;
                pcs.css.doc2_pmat_bevel_backgroundColor = `white`;
                pcs.css.doc2_pmat_bevel_left = `${RailSidePx + DocWidthPx + DoubleDocSeparationPx - BevelWidthPx}px`;
                pcs.css.doc2_pmat_bevel_top = `${RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - Doc2HeightPx / 2) - BevelWidthPx}px`;
                pcs.css.doc2_pmat_bevel_width = `${Doc2WidthPx + BevelWidthPx * 2}px`;
                pcs.css.doc2_pmat_bevel_height = `${Doc2HeightPx + BevelWidthPx * 2}px`;
            }
            r.renderCollapsedSMat(pcs);
            pcs.css.doc2_smat_backgroundColor = `none`;
            pcs.css.doc2_smat_left = `0px`;
            pcs.css.doc2_smat_top = `0px`;
            pcs.css.doc2_smat_width = ``;
            pcs.css.doc2_smat_height = ``;
            pcs.css.doc2_smat_bevel_backgroundColor = `none`;
            pcs.css.doc2_smat_bevel_left = `0px`;
            pcs.css.doc2_smat_bevel_top = `0px`;
            pcs.css.doc2_smat_bevel_width = ``;
            pcs.css.doc2_smat_bevel_height = ``;
        }

        if (!doCampusAlternate) {
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
            pcs.css.doc2_visible = true;
            pcs.css.doc2_src =
                pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Campus_Scene)
                    ? r.campus_path(pcs.FramePartDomain, pcs.Base_ExtraEntityName)
                    : r.doc_path(pcs, Doc2WidthPx, Doc2HeightPx, pcs.Base_DocumentName2 ? pcs.Base_DocumentName2 : pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o4, pcs.Base_ExtraID > 1);
            pcs.css.doc2_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc2_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc2_width = `${Doc2WidthPx.toString()}px`;
            pcs.css.doc2_height = `${Doc2HeightPx.toString()}px`;
        } else {
            pcs.css.doc1_src = pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Campus_Scene) ? r.campus_path(pcs.FramePartDomain, pcs.Base_ExtraEntityName) : r.doc_path(pcs, Doc2WidthPx, Doc2HeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
            pcs.css.doc2_visible = true;
            pcs.css.doc2_src = r.doc_path(pcs, original_vertical ? 500 : 2000, original_vertical ? 2000 : 500, pcs.Base_DocumentName ? pcs.Base_DocumentName : pcs.Base_DocumentName, '', pcs.DYF_FrameStyleID, pcs.o4, false);
            pcs.css.doc2_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc2_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc2_width = `${Doc2WidthPx.toString()}px`;
            pcs.css.doc2_height = `${Doc2HeightPx.toString()}px`;
        }

        // insignia
        if (pcs.ProductTypeID === 88) {
            // double b
            if (pcs.Base_ExtraID < 1) {
                r.renderBottomInsignia(0, 0, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, pcs);
            } else {
                r.renderBottomInsignia(0, 0, PMatWidthPx - DoubleDocSeparationPx - Doc2WidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, DocHeightPx, pcs);
            }
        } else {
            // all other double
            r.renderStandardInsignia(0, 0, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, pcs);
            if (doCampusAlternate) {
                pcs.css.insignia_left = `${RailSidePx + DocWidthPx + DoubleDocSeparationPx - BevelWidthPx + (Doc2WidthPx + BevelWidthPx * 2 - MaxInsigniaWidthPx) / 2}px`;
            }
        }

        // lino
        if (pcs.ProductTypeID === 88) {
            // double b
            if (pcs.Base_ExtraID < 1) {
                r.renderTopLino(0, 0, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, DocWidthPx + DoubleDocSeparationPx + Doc2WidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, pcs);
            } else {
                r.renderTopLino(0, 0, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, pcs);
            }
        } else {
            // all other double
            pcs.css.lino_visible = pcs.Base_LinoID > 0;
            if (pcs.Base_LinoID > 0) {
                pcs.css.lino_src = r.lino_path(LinoWidthMaxPx, pcs);
                pcs.css.lino_left = `${<number>(<any>Math.floor(<number>(<any>(PMatWidthPx / 2)) - <number>(<any>(LinoWidthMaxPx / 2))))}px`;
                if (doCampusAlternate) {
                    pcs.css.lino_left = `${RailSidePx + DocWidthPx + DoubleDocSeparationPx - BevelWidthPx + (Doc2WidthPx + BevelWidthPx * 2 - LinoWidthMaxPx) / 2}px`;
                }

                pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
                pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
                if (pcs.isHorizontal) {
                    pcs.css.lino_top = `${<number>(<any>(RailTopPx + DocHeightPx + DoubleDocSeparationPx + Doc2HeightPx + <number>(<any>BevelWidthPx) + SMatCount * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx)) + Math.floor(<number>(<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * <number>(SMatWidthPx + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>LinoHeightMaxPx) / 2)))}px`;
                } else {
                    pcs.css.lino_top = `${<number>(<any>(RailTopPx + Math.max(DocHeightPx, Doc2HeightPx) + BevelWidthPx + SMatCount * (SMatWidthPx + BevelWidthPx) + Math.floor(<number>(<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * <number>(<any>(SMatWidthPx + BevelWidthPx))) / 2 - <number>(<any>LinoHeightMaxPx) / 2)))}px`;
                }
            }
        }

        // ep
        pcs.css.ep_visible = pcs.HasEngravedPlate;
        if (pcs.HasEngravedPlate) {
            let epDocWidth: number = <number>(<any>Math.round((Math.max(pcs.Document_Width, pcs.Document2_Width) - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            let EPTopPx: number = -1;
            let EPLeftPx: number = <number>(<any>Math.floor(<number>(<any>(PMatWidthPx / 2)) - <number>(<any>EPWidthPx) / 2));
            if (pcs.isHorizontal) {
                EPTopPx = <number>(
                    (<any>(
                        (RailTopPx +
                            DocHeightPx +
                            <number>(<any>DoubleDocSeparationPx) +
                            Doc2HeightPx +
                            BevelWidthPx +
                            SMatCount * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx)) +
                            (RailTopPx - <number>(<any>BevelWidthPx) - SMatCount * (<number>(<any>SMatWidthPx) + BevelWidthPx) - EPHeightPx - <number>(<any>BevelWidthPx) * 4) / 2)
                    ))
                );
            } else {
                EPTopPx = <number>(
                    (<any>(RailTopPx + Math.max(DocHeightPx, Doc2HeightPx) + BevelWidthPx + SMatCount * (<number>(<any>SMatWidthPx) + BevelWidthPx) + (RailTopPx - <number>(<any>BevelWidthPx) - SMatCount * (SMatWidthPx + <number>(<any>BevelWidthPx)) - EPHeightPx - BevelWidthPx * 4) / 2))
                );
            }
            r.renderEngravedPlate(EPLeftPx, EPTopPx, EPWidthPx, EPHeightPx, BevelWidthPx, PMatWidthPx, pcs);
        }
        if (pcs.DYF_FrameStyleID == <number>(<any>DYF_FrameStylesEnum.Campus_Scene)) {
            if (SMatCount > 0) {
                if (pcs.isHorizontal) {
                    pcs.css.doc1_pmat_bevel_top = `${(RailTopPx + Doc2HeightPx + DoubleDocSeparationPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                    pcs.css.doc2_pmat_bevel_top = `${(RailTopPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                } else {
                    pcs.css.doc1_pmat_bevel_top = `${(RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - DocHeightPx / 2) - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                    pcs.css.doc2_pmat_bevel_top = `${(RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - Doc2HeightPx / 2) - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
                }
            } else {
                if (pcs.isHorizontal) {
                    pcs.css.doc1_pmat_bevel_top = `${RailTopPx + Doc2HeightPx + DoubleDocSeparationPx - BevelWidthPx}px`;
                    pcs.css.doc2_pmat_bevel_top = `${RailTopPx - BevelWidthPx}px`;
                } else {
                    pcs.css.doc1_pmat_bevel_top = `${RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - DocHeightPx / 2) - BevelWidthPx}px`;
                    pcs.css.doc2_pmat_bevel_top = `${RailTopPx + ((PMatHeightPx - 2 * RailTopPx) / 2 - Doc2HeightPx / 2) - BevelWidthPx}px`;
                }
            }
        }
    };

    const renderCentury = (pcs: ProductCustomizationState): void => {
        let CurrentDocWidth: number = 0;
        let CurrentDocHeight: number = 0;
        let DocSizeTier = r.getDocSizeTier(pcs);
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;

        if (pcs.Document_Width > WidthLimit) {
            let ratio: number = WidthLimit / pcs.Document_Width;
            pcs.Document_Width = WidthLimit;
            pcs.Document_Height = pcs.Document_Height * ratio;
        }
        if (pcs.Document_Height > HeightLimit) {
            let ratio: number = HeightLimit / pcs.Document_Height;
            pcs.Document_Height = HeightLimit;
            pcs.Document_Width = pcs.Document_Width * ratio;
        }
        CurrentDocWidth = pcs.Document_Width;
        CurrentDocHeight = pcs.Document_Height;

        let SMatCount: number = !pcs.MatCombo_IsWoodFillet && pcs.SecondaryMatID > 0 ? 1 : 0;
        let SMatWidthPixelAdder: number = 1;
        let MouldingInsigniaAreaWidth: number = <number>(<any>pcs.MouldingExtWidth) - 0.2;
        let MouldingInsigniaVerticalOffset: number = -0.115;
        // Rail Setup
        // - Rail includes: Inner Mat and all mat bevels.
        // - The primary mat is actually the inner mat on single document frames
        // - The document "underlaps" the inner mat. See DocSizeTier.DocOverLap
        // - The mats are overlapped by the moulding by 0.25
        // - From this point forward, rail will be defined as all visible portions of mats including bevels (we are subtracting out the 0.25 of moulding overlap)
        let MouldingOverlap: number = 0.25;
        let RailTop: number = Util.isNullOrWhiteSpace(pcs.PrimaryMatName) ? 0 : 0.875; // We assume that millenniums have a primary mat, and century frames do not.
        if (!Util.isNullOrWhiteSpace(pcs.PrimaryMatName) && pcs.Document_Width >= 12 && pcs.Document_Height >= 12) {
            RailTop = 1.5;
        } // millenium mat sizing info: https://trello.com/c/Z0Vb4nEz/326-framestyles-century-millennium// millenium mat sizing info: https://trello.com/c/Z0Vb4nEz/326-framestyles-century-millennium
        if (!Util.isNullOrWhiteSpace(pcs.PrimaryMatName) && pcs.Document_Width >= 16 && pcs.Document_Height >= 16) {
            RailTop = 1.875;
        }
        let RailSide: number = RailTop;
        // Insignia Adjustments
        let InsigniaWidth: number = pcs.Base_InsigniaWidthInches > 0 ? <number>(<any>pcs.Base_InsigniaWidthInches) : <number>(<any>DefaultPCS.DefaultInsigniaWidthMax);
        // ****----____ EP-code-change ____----****
        let EPWidth: number = DefaultPCS.DefaultEPWidth;
        let EPHeight: number = DefaultPCS.DefaultEPHeight;
        if (CurrentDocHeight <= 7) {
            EPWidth = 3;
            EPHeight = 0.5;
        }
        // ****----____ EP-code-change ____----****
        let TotalWidth: number = <number>(<any>(RailSide * 2 + <number>(<any>CurrentDocWidth))) + (pcs.UseMaxMouldingForSizing ? pcs.MouldingWidthMax * 2 : pcs.MouldingExtWidth * 2);
        let DPI: number = <number>(<any>Math.floor((pcs.MaxFrameWidthPx + 4) / TotalWidth)); // add 4. Yes, it's cheating, but we always round down and actually have a bit more room to work with.
        let done: boolean = false;
        let doneCount: number = 0;
        let BevelWidthPx: number = -1;
        let DocWidthPx: number = -1;
        let DocHeightPx: number = -1;
        let EPWidthPx: number = -1;
        let EPHeightPx: number = -1;
        let MouldingInsigniaAreaWidthPx: number = -1;
        let MouldingInsigniaVerticalOffsetPx: number = -1;
        let MaxInsigniaWidthPx: number = -1;
        let MouldingWidthPx: number = -1;
        let MaxMouldingWidthPx: number = -1;
        let RailSidePx: number = -1;
        let RailTopPx: number = -1;
        let RailBottomPx: number = -1;
        let SMatWidthPx: number = -1;
        let TotalUsedWidthPx: number = -1;
        let TotalUsedWidthPx_NoMargin: number = -1;
        let MaxSingleDocRailWidthPx: number = -1;
        let MaxPossibleSingleDocWidthPx: number = -1;
        let MaxPossibleSingleDocHeightPx: number = -1;
        let PMatWidthPx: number = -1;
        let TotalUsedHeightPx: number = -1;
        let TotalUsedHeightPx_NoMargin: number = -1;
        let PMatHeightPx: number = -1;
        let WoodFilletWidthPx: number = -1;
        while (!done) {
            doneCount += 1;
            BevelWidthPx = Math.max(1, <number>(<any>Math.round(pcs.BevelWidth * 2 * DPI))); // double bevel width. It was too small.
            DocWidthPx = <number>(<any>Math.round((CurrentDocWidth - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DocHeightPx = <number>(<any>Math.round((CurrentDocHeight - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            // ****----____ EP-code-change ____----****
            EPWidthPx = getEPWidth(pcs, DPI, EPWidth, DocWidthPx);
            EPHeightPx = getEPHeight(pcs, DPI, EPHeight, DocHeightPx);
            // ****----____ EP-code-change ____----****
            MouldingInsigniaAreaWidthPx = <number>(<any>Math.round(MouldingInsigniaAreaWidth * DPI));
            MouldingInsigniaVerticalOffsetPx = <number>(<any>Math.round(MouldingInsigniaVerticalOffset * DPI));
            MaxInsigniaWidthPx = <number>(<any>Math.round(InsigniaWidth * DPI));
            MaxInsigniaWidthPx = Math.min(MouldingInsigniaAreaWidthPx, MaxInsigniaWidthPx);
            MouldingWidthPx = <number>(<any>Math.round(pcs.MouldingExtWidth * DPI));
            MaxMouldingWidthPx = <number>(<any>Math.round(pcs.MouldingWidthMax * DPI));
            pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
            RailSidePx = <number>(<any>Math.round(RailSide * DPI)) + SMatWidthPixelAdder * SMatCount; // we add the smat pixel adder because this adder is not accounted for in the core rail size specs
            RailTopPx = <number>(<any>Math.round(RailTop * DPI)) + SMatWidthPixelAdder * SMatCount;
            RailBottomPx = getRailBottomForDynamicEP(pcs, RailTopPx, EPHeightPx);
            SMatWidthPx = Math.max(1, <number>(<any>Math.floor((pcs.InnerAccentWidth - pcs.BevelWidth) * DPI))) + SMatWidthPixelAdder; // innerAccentWidth includes bevel. We take bevel out here as we convert to pixels.
            if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
                SMatWidthPx = 2;
            } // Cap SMat at 2px for images at or below 250px// Cap SMat at 2px for images at or below 250px
            TotalUsedWidthPx = RailSidePx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            TotalUsedWidthPx_NoMargin = RailSidePx * 2 + DocWidthPx + MouldingWidthPx * 2;
            // calculate the maximum possible width of a single doc frame with this document size. This is used to establish a common DPI across all single docs when UseCommonDPI is set to true
            MaxSingleDocRailWidthPx = Math.max(
                <number>(<any>Math.round((<number>(<any>DocSizeTier.CameoRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder,
                <number>(<any>Math.round((<number>(<any>DocSizeTier.StandardRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder + (BevelWidthPx * 2 + SMatWidthPx),
            ); // we use the larger cameo rail for this calculation. Also, compare against standard rail + fillet. Take the largest
            MaxPossibleSingleDocWidthPx = MaxSingleDocRailWidthPx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            MaxPossibleSingleDocHeightPx = MaxSingleDocRailWidthPx * 2 + DocHeightPx + MaxMouldingWidthPx * 2;
            PMatWidthPx = TotalUsedWidthPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            TotalUsedHeightPx = RailTopPx + RailBottomPx + DocHeightPx + MaxMouldingWidthPx * 2;
            TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + DocHeightPx + MouldingWidthPx * 2;
            PMatHeightPx = TotalUsedHeightPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            WoodFilletWidthPx = BevelWidthPx * 2 + SMatWidthPx;
            // if UseCommonDPI is turned on, we want to sync single doc, cameo, and spirit. We sync them in such a way that, if turned on their side, vertical frames will still fit.
            if (DocHeightPx > DocWidthPx && pcs.UseCommonDPI) {
                if (MaxPossibleSingleDocHeightPx > pcs.MaxFrameWidthPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            } else {
                if ((pcs.UseCommonDPI ? MaxPossibleSingleDocWidthPx : TotalUsedWidthPx_NoMargin) > pcs.MaxFrameWidthPx || (pcs.UseCommonDPI ? TotalUsedHeightPx : TotalUsedHeightPx_NoMargin) > pcs.MaxFrameHeightPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            }
            if (doneCount > 100000) {
                done = true;
            }
        }

        // set DPI to a global object
        pcs.DPI = DPI;
        // check width, look back with new dpi if necessary
        pcs.FrameDisplay_width = TotalUsedWidthPx;
        pcs.FrameDisplay_height = TotalUsedHeightPx;
        // primary mat
        r.renderStandardPrimaryMat(pcs.FramePartDomain, PMatWidthPx, PMatHeightPx, MaxMouldingWidthPx, MouldingWidthPx, pcs);
        r.renderStandardMoulding(MouldingWidthPx, PMatWidthPx, PMatHeightPx, pcs);
        // secondary mat
        if (!Util.isNullOrWhiteSpace(pcs.PrimaryMatName)) {
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
            r.renderCollapsedSMat(pcs);
            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        } else {
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
            r.renderCollapsedPMatBevel(pcs);
            r.renderCollapsedSMat(pcs);

            pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
            pcs.css.doc1_left = `0px`;
            pcs.css.doc1_top = `0px`;
            pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
            pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        }
        // insignia
        pcs.css.insignia_visible = pcs.Base_InsigniaID > 0;
        if (pcs.Base_InsigniaID > 0) {
            pcs.css.insignia_src = r.insignia_path_noBevel(pcs.FramePartDomain, MaxInsigniaWidthPx, pcs.Base_InsigniaName);
            pcs.css.insignia_left = `${(<number>(<any>Math.floor(<number>(<any>(PMatWidthPx / 2)) - <number>(<any>(MaxInsigniaWidthPx / 2))))).toString()}px`;
            pcs.css.insignia_top = `${(-1 * <number>(<any>Math.floor(<number>(<any>(MouldingWidthPx - BevelWidthPx)) / 2 - MaxInsigniaWidthPx / 2)) - MaxInsigniaWidthPx + MouldingInsigniaVerticalOffsetPx).toString()}px`;
            pcs.css.insignia_width = `${MaxInsigniaWidthPx.toString()}px`;
            pcs.css.insignia_height = `${MaxInsigniaWidthPx.toString()}px`;
        }
    };

    const renderVarsity = (pcs: ProductCustomizationState): void => {
        let CurrentDocWidth: number = 0;
        let CurrentDocHeight: number = 0;
        let DocSizeTier = r.getDocSizeTier(pcs);
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;

        if (pcs.Document_Width > WidthLimit) {
            let ratio: number = WidthLimit / pcs.Document_Width;
            pcs.Document_Width = WidthLimit;
            pcs.Document_Height = pcs.Document_Height * ratio;
        }
        if (pcs.Document_Height > HeightLimit) {
            let ratio: number = HeightLimit / pcs.Document_Height;
            pcs.Document_Height = HeightLimit;
            pcs.Document_Width = pcs.Document_Width * ratio;
        }
        CurrentDocWidth = pcs.Document_Width;
        CurrentDocHeight = pcs.Document_Height;

        let SMatCount: number = !pcs.MatCombo_IsWoodFillet && pcs.SecondaryMatID > 0 ? 1 : 0;
        let SMatWidthPixelAdder: number = 1;
        // rail Setup
        // - Rail includes: Inner Mat and all mat bevels.
        // - The primary mat is actually the inner mat on single document frames
        // - The document "underlaps" the inner mat. See DocSizeTier.DocOverLap
        // - The mats are overlapped by the moulding by 0.25
        // - From this point forward, rail will be defined as all visible portions of mats including bevels (we are subtracting out the 0.25 of moulding overlap)
        let MouldingOverlap: number = 0.25;
        let RailTop: number = <number>(<any>DocSizeTier.StandardRail) - MouldingOverlap;
        let RailSide: number = <number>(<any>DocSizeTier.StandardRail) - MouldingOverlap;
        // insignia Adjustments
        let InsigniaWidth = pcs.Base_InsigniaWidthInches > 0 ? pcs.Base_InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
        InsigniaWidth = DocSizeTier.DocSizeTierID >= 7 && pcs.Base_InsigniaWidthInches < 1 ? 2 : InsigniaWidth;
        // lino
        let LinoWidthMax: number = Math.min(DefaultPCS.DefaultLinoWidthMax, CurrentDocWidth + 1) + pcs.Base_LinoAdjustmentInches;
        LinoWidthMax = r.linoWidthAdjust(LinoWidthMax, pcs);
        let LinoHeightMax: number = DefaultPCS.DefaultLinoHeightMax * (LinoWidthMax / 11.5);
        // ****----____ EP-code-change ____----****
        let EPWidth: number = DefaultPCS.DefaultEPWidth;
        let EPHeight: number = DefaultPCS.DefaultEPHeight;
        if (CurrentDocHeight <= 7) {
            EPWidth = 3;
            EPHeight = 0.5;
        }
        // ****----____ EP-code-change ____----****
        let TotalWidth: number = RailSide * 2 + CurrentDocWidth + (pcs.UseMaxMouldingForSizing ? pcs.MouldingWidthMax * 2 : pcs.MouldingExtWidth * 2);
        let DPI: number = <number>(<any>Math.floor(pcs.MaxFrameWidthPx / TotalWidth));
        let done: boolean = false;
        let doneCount: number = 0;
        let BevelWidthPx: number = -1;
        let DocWidthPx: number = -1;
        let DocHeightPx: number = -1;
        let EPWidthPx: number = -1;
        let EPHeightPx: number = -1;
        let MaxInsigniaWidthPx: number = -1;
        let LinoWidthMaxPx: number = -1;
        let LinoHeightMaxPx: number = -1;
        let MouldingWidthPx: number = -1;
        let MaxMouldingWidthPx: number = -1;
        let SMatWidthPx: number = -1;
        let RailSidePx: number = -1;
        let RailTopPx: number = -1;
        let RailBottomPx: number = -1;
        let TotalUsedWidthPx: number = -1;
        let TotalUsedWidthPx_NoMargin: number = -1;
        let PMatWidthPx: number = -1;
        let TotalUsedHeightPx: number = -1;
        let TotalUsedHeightPx_NoMargin: number = -1;
        let PMatHeightPx: number = -1;
        let MaxSingleDocRailWidthPx: number = -1;
        let MaxPossibleSingleDocWidthPx: number = -1;
        let MaxPossibleSingleDocHeightPx: number = -1;
        while (!done) {
            BevelWidthPx = Math.max(1, <number>(<any>Math.floor(pcs.BevelWidth * 2 * DPI))); // double bevel width. It was too small.
            DocWidthPx = <number>(<any>Math.round((CurrentDocWidth - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DocHeightPx = <number>(<any>Math.round((CurrentDocHeight - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            // ****----____ EP-code-change ____----****
            EPWidthPx = getEPWidth(pcs, DPI, EPWidth, DocWidthPx);
            EPHeightPx = getEPHeight(pcs, DPI, EPHeight, DocHeightPx);
            // ****----____ EP-code-change ____----****
            MaxInsigniaWidthPx = <number>(<any>Math.round(InsigniaWidth * DPI));
            LinoWidthMaxPx = <number>(<any>Math.round(LinoWidthMax * DPI));
            LinoHeightMaxPx = <number>(<any>Math.round(LinoHeightMax * DPI));
            MouldingWidthPx = <number>(<any>Math.round(pcs.MouldingExtWidth * DPI));
            MaxMouldingWidthPx = <number>(<any>Math.round(pcs.MouldingWidthMax * DPI));
            pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
            SMatWidthPx = Math.max(1, <number>(<any>Math.floor((pcs.InnerAccentWidth - pcs.BevelWidth) * DPI))) + SMatWidthPixelAdder; // innerAccentWidth includes bevel. We take bevel out here as we convert to pixels. Adding +1 pixel here. We might have to loop back and adjust DPI down
            RailSidePx = <number>(<any>Math.round(RailSide * DPI)) + SMatWidthPixelAdder * SMatCount; // we add the smat pixel adder because this adder is not accounted for in the core rail size specs. Also, if it is a wood fillet, we must add the wood fillet to the rail size since the fillet is additive
            RailTopPx = <number>(<any>Math.round(RailTop * DPI)) + SMatWidthPixelAdder * SMatCount;
            RailBottomPx = getRailBottomForDynamicEP(pcs, RailTopPx, EPHeightPx);
            if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
                SMatWidthPx = 2;
            } // Cap SMat at 2px for images at or below 250px// Cap SMat at 2px for images at or below 250px
            TotalUsedWidthPx = RailSidePx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            TotalUsedWidthPx_NoMargin = RailSidePx * 2 + DocWidthPx + MouldingWidthPx * 2;
            PMatWidthPx = TotalUsedWidthPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            TotalUsedHeightPx = RailTopPx + RailBottomPx + DocHeightPx + MaxMouldingWidthPx * 2;
            TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + DocHeightPx + MouldingWidthPx * 2;
            PMatHeightPx = TotalUsedHeightPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            // if UseCommonDPI is turned on, we want to sync single doc, cameo, and spirit. We sync them in such a way that, if turned on their side, vertical frames will still fit.
            // calculate the maximum possible width of a single doc frame with this document size. This is used to establish a common DPI across all single docs when UseCommonDPI is set to true
            MaxSingleDocRailWidthPx = Math.max(
                <number>(<any>Math.round((<number>(<any>DocSizeTier.CameoRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder,
                <number>(<any>Math.round((<number>(<any>DocSizeTier.StandardRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder + (BevelWidthPx * 2 + SMatWidthPx),
            ); // we use the larger cameo rail for this calculation. Also, compare against standard rail + fillet. Take the largest
            MaxPossibleSingleDocWidthPx = MaxSingleDocRailWidthPx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            MaxPossibleSingleDocHeightPx = MaxSingleDocRailWidthPx * 2 + DocHeightPx + MaxMouldingWidthPx * 2;
            if (DocHeightPx > DocWidthPx && pcs.UseCommonDPI) {
                if (MaxPossibleSingleDocHeightPx > pcs.MaxFrameWidthPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            } else {
                if ((pcs.UseCommonDPI ? MaxPossibleSingleDocWidthPx : TotalUsedWidthPx_NoMargin) > pcs.MaxFrameWidthPx || (pcs.UseCommonDPI ? TotalUsedHeightPx : TotalUsedHeightPx_NoMargin) > pcs.MaxFrameHeightPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            }
            doneCount += 1;
            if (doneCount > 100000) {
                done = true;
            }
        }

        // set DPI to a global object
        pcs.DPI = DPI;
        // check width, look back with new dpi if necessary
        pcs.FrameDisplay_width = TotalUsedWidthPx;
        pcs.FrameDisplay_height = TotalUsedHeightPx;
        // primary mat
        r.renderStandardPrimaryMat(pcs.FramePartDomain, PMatWidthPx, PMatHeightPx, MaxMouldingWidthPx, MouldingWidthPx, pcs);
        r.renderStandardMoulding(MouldingWidthPx, PMatWidthPx, PMatHeightPx, pcs);
        pcs.css.varsity_visible = true;
        if (SMatCount > 0) {
            pcs.css.varsity_pmat_bevel_backgroundColor = `white`;
            pcs.css.varsity_pmat_bevel_left = `${(RailSidePx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.varsity_pmat_bevel_top = `${(RailTopPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.varsity_pmat_bevel_width = `${(DocWidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)).toString()}px`;
            pcs.css.varsity_pmat_bevel_height = `${(DocHeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)).toString()}px`;
            pcs.css.varsity_smat_backgroundColor = `#${pcs.SecondaryMatColor}`;
            pcs.css.varsity_smat_left = `${BevelWidthPx.toString()}px`;
            pcs.css.varsity_smat_top = `${BevelWidthPx.toString()}px`;
            pcs.css.varsity_smat_width = `${(DocWidthPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
            pcs.css.varsity_smat_height = `${(DocHeightPx + SMatWidthPx * 2 + BevelWidthPx * 2).toString()}px`;
            pcs.css.varsity_smat_bevel_backgroundColor = `white`;
            pcs.css.varsity_smat_bevel_left = `${SMatWidthPx.toString()}px`;
            pcs.css.varsity_smat_bevel_top = `${SMatWidthPx.toString()}px`;
            pcs.css.varsity_smat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.varsity_smat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
        } else {
            pcs.css.varsity_pmat_bevel_backgroundColor = `white`;
            pcs.css.varsity_pmat_bevel_left = `${(RailSidePx - BevelWidthPx).toString()}px`;
            pcs.css.varsity_pmat_bevel_top = `${(RailTopPx - BevelWidthPx).toString()}px`;
            pcs.css.varsity_pmat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.varsity_pmat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.varsity_smat_backgroundColor = `none`;
            pcs.css.varsity_smat_left = `0px`;
            pcs.css.varsity_smat_top = `0px`;
            pcs.css.varsity_smat_width = ``;
            pcs.css.varsity_smat_height = ``;
            pcs.css.varsity_smat_bevel_backgroundColor = `none`;
            pcs.css.varsity_smat_bevel_left = `0px`;
            pcs.css.varsity_smat_bevel_top = `0px`;
            pcs.css.varsity_smat_bevel_width = ``;
            pcs.css.varsity_smat_bevel_height = ``;
        }

        pcs.css.varsity_bg_backgroundColor = `#${Util.isNullOrWhiteSpace(pcs.VL_BG_Color) ? `000000` : pcs.VL_BG_Color}`;
        pcs.css.varsity_bg_left = `${BevelWidthPx.toString()}px`;
        pcs.css.varsity_bg_top = `${BevelWidthPx.toString()}px`;
        pcs.css.varsity_bg_width = `${DocWidthPx.toString()}px`;
        pcs.css.varsity_bg_height = `${DocHeightPx.toString()}px`;
        pcs.css.varsity_src = r.vl_path(pcs.FramePartDomain, DocWidthPx, DocHeightPx, pcs.Base_ExtraEntityName);
        pcs.css.varsity_left = `0px`;
        pcs.css.varsity_top = `0px`;
        pcs.css.varsity_width = `${DocWidthPx.toString()}px`;
        pcs.css.varsity_height = `${DocHeightPx.toString()}px`;
        // insignia
        r.renderStandardInsignia(0, 0, PMatWidthPx, MaxInsigniaWidthPx, RailTopPx, BevelWidthPx, SMatCount, SMatWidthPx, pcs);
        r.renderStandardLino(0, 0, BevelWidthPx, SMatCount, SMatWidthPx, RailSidePx, RailTopPx, DocWidthPx, DocHeightPx, LinoWidthMaxPx, LinoHeightMaxPx, pcs);
        pcs.css.ep_visible = pcs.HasEngravedPlate;
        if (pcs.HasEngravedPlate) {
            pcs.css.ep_visible = true;
            let EPTopPx: number =
                <number>(RailSidePx + DocHeightPx + BevelWidthPx + SMatCount * (SMatWidthPx + BevelWidthPx)) +
                <number>(<any>Math.floor((<number>(<any>RailSidePx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>EPHeightPx) / 2)) -
                BevelWidthPx * 2;
            let EPLeftPx: number = <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>EPWidthPx) / 2)) - BevelWidthPx * 2;
            r.renderEngravedPlate(EPLeftPx, EPTopPx, EPWidthPx, EPHeightPx, BevelWidthPx, PMatWidthPx, pcs);
        }
    };

    const renderOvalFrame = (pcs: ProductCustomizationState): void => {
        let CurrentDocWidth: number = 0;
        let CurrentDocHeight: number = 0;
        let DocSizeTier = r.getDocSizeTier(pcs);
        let WidthLimit: number = 14;
        let HeightLimit: number = 14;

        if (pcs.Document_Width > WidthLimit) {
            let ratio: number = WidthLimit / pcs.Document_Width;
            pcs.Document_Width = WidthLimit;
            pcs.Document_Height = pcs.Document_Height * ratio;
        }
        if (pcs.Document_Height > HeightLimit) {
            let ratio: number = HeightLimit / pcs.Document_Height;
            pcs.Document_Height = HeightLimit;
            pcs.Document_Width = pcs.Document_Width * ratio;
        }
        CurrentDocWidth = pcs.Document_Width;
        CurrentDocHeight = pcs.Document_Height;
        let SMatCount: number = !pcs.MatCombo_IsWoodFillet && pcs.SecondaryMatID > 0 ? 1 : 0;
        let SMatWidthPixelAdder: number = 1;
        // rail Setup
        // - Rail includes: Inner Mat and all mat bevels.
        // - The primary mat is actually the inner mat on single document frames
        // - The document "underlaps" the inner mat. See DocSizeTier.DocOverLap
        // - The mats are overlapped by the moulding by 0.25
        // - From this point forward, rail will be defined as all visible portions of mats including bevels (we are subtracting out the 0.25 of moulding overlap)
        let MouldingOverlap: number = 0.25;
        let RailTop: number = <number>(<any>DocSizeTier.TasselRailHeight) - MouldingOverlap;
        let RailSide: number = <number>(<any>DocSizeTier.TasselRailWidth) - MouldingOverlap;
        // insignia Adjustments
        let InsigniaWidth = pcs.Base_InsigniaWidthInches > 0 ? pcs.Base_InsigniaWidthInches : DefaultPCS.DefaultInsigniaWidthMax;
        InsigniaWidth = DocSizeTier.DocSizeTierID >= 7 && pcs.Base_InsigniaWidthInches < 1 ? 2 : InsigniaWidth;
        // lino
        let LinoWidthMax: number = Math.min(DefaultPCS.DefaultLinoWidthMax, CurrentDocWidth + 1) + pcs.Base_LinoAdjustmentInches;
        LinoWidthMax = r.linoWidthAdjust(LinoWidthMax, pcs);
        let LinoHeightMax: number = DefaultPCS.DefaultLinoHeightMax * (LinoWidthMax / 11.5);
        let OvalGap: number = 1;
        let OvalWidth: number = 4.5;
        let OvalHeight: number = 6.5;
        // ****----____ EP-code-change ____----****
        let EPWidth: number = DefaultPCS.DefaultEPWidth;
        let EPHeight: number = DefaultPCS.DefaultEPHeight;
        if (CurrentDocHeight <= 7) {
            EPWidth = 3;
            EPHeight = 0.5;
        }
        // ****----____ EP-code-change ____----****
        let TotalWidth: number = RailSide * 2 + CurrentDocWidth + (pcs.UseMaxMouldingForSizing ? pcs.MouldingWidthMax * 2 : pcs.MouldingExtWidth * 2) + OvalGap + OvalWidth;
        let DPI: number = <number>(<any>Math.floor(pcs.MaxFrameWidthPx / TotalWidth));
        let done: boolean = false;
        let doneCount: number = -1;
        let BevelWidthPx: number = -1;
        let DocWidthPx: number = -1;
        let DocHeightPx: number = -1;
        let EPWidthPx: number = -1;
        let EPHeightPx: number = -1;
        let MaxInsigniaWidthPx: number = -1;
        let LinoWidthMaxPx: number = -1;
        let LinoHeightMaxPx: number = -1;
        let MouldingWidthPx: number = -1;
        let MaxMouldingWidthPx: number = -1;
        let SMatWidthPx: number = -1;
        let RailSidePx: number = -1;
        let RailTopPx: number = -1;
        let RailBottomPx: number = -1;
        let OvalGapPx: number = -1;
        let OvalWidthPx: number = -1;
        let OvalHeightPx: number = -1;
        let TotalUsedWidthPx: number = -1;
        let TotalUsedWidthPx_NoMargin: number = -1;
        let PMatWidthPx: number = -1;
        let TotalUsedHeightPx: number = -1;
        let TotalUsedHeightPx_NoMargin: number = -1;
        let PMatHeightPx: number = -1;
        let MaxSingleDocRailWidthPx: number = -1;
        let MaxPossibleSingleDocWidthPx: number = -1;
        let MaxPossibleSingleDocHeightPx: number = -1;
        while (!done) {
            BevelWidthPx = Math.max(1, <number>(<any>Math.round(pcs.BevelWidth * 2 * DPI))); // double bevel width. It was too small.
            DocWidthPx = <number>(<any>Math.round((CurrentDocWidth - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            DocHeightPx = <number>(<any>Math.round((CurrentDocHeight - <number>(<any>DocSizeTier.DocOverlap)) * DPI));
            // ****----____ EP-code-change ____----****
            EPWidthPx = getEPWidth(pcs, DPI, EPWidth, DocWidthPx);
            EPHeightPx = getEPHeight(pcs, DPI, EPHeight, DocHeightPx);
            // ****----____ EP-code-change ____----****
            MaxInsigniaWidthPx = <number>(<any>Math.round(InsigniaWidth * DPI));
            LinoWidthMaxPx = <number>(<any>Math.round(LinoWidthMax * DPI));
            LinoHeightMaxPx = <number>(<any>Math.round(LinoHeightMax * DPI));
            MouldingWidthPx = <number>(<any>Math.round(pcs.MouldingExtWidth * DPI));
            MaxMouldingWidthPx = <number>(<any>Math.round(pcs.MouldingWidthMax * DPI));
            pcs.Padding = MaxMouldingWidthPx - MouldingWidthPx;
            SMatWidthPx = Math.max(1, <number>(<any>Math.floor((pcs.InnerAccentWidth - pcs.BevelWidth) * DPI))) + SMatWidthPixelAdder; // innerAccentWidth includes bevel. We take bevel out here as we convert to pixels. Adding +1 pixel here. We might have to loop back and adjust DPI down
            RailSidePx = <number>(<any>Math.round(RailSide * DPI)) + SMatWidthPixelAdder * SMatCount; // we add the smat pixel adder because this adder is not accounted for in the core rail size specs. Also, if it is a wood fillet, we must add the wood fillet to the rail size since the fillet is additive
            RailTopPx = <number>(<any>Math.round(RailTop * DPI)) + SMatWidthPixelAdder * SMatCount;
            RailBottomPx = getRailBottomForDynamicEP(pcs, RailTopPx, EPHeightPx);
            if (pcs.MaxFrameWidthPx <= 250 && SMatWidthPx > 2) {
                SMatWidthPx = 2;
            } // Cap SMat at 2px for images at or below 250px// Cap SMat at 2px for images at or below 250px
            OvalGapPx = <number>(<any>Math.round(OvalGap * DPI)) + SMatWidthPixelAdder * SMatCount * 2;
            OvalWidthPx = <number>(<any>Math.round(OvalWidth * DPI));
            OvalHeightPx = <number>(<any>Math.round(OvalHeight * DPI));
            TotalUsedWidthPx = RailSidePx * 2 + DocWidthPx + MaxMouldingWidthPx * 2 + OvalGapPx + OvalWidthPx;
            TotalUsedWidthPx_NoMargin = RailSidePx * 2 + DocWidthPx + MouldingWidthPx * 2 + OvalGapPx + OvalWidthPx;
            PMatWidthPx = TotalUsedWidthPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            TotalUsedHeightPx = RailTopPx + RailBottomPx + DocHeightPx + MaxMouldingWidthPx * 2;
            TotalUsedHeightPx_NoMargin = RailTopPx + RailBottomPx + DocHeightPx + MouldingWidthPx * 2;
            PMatHeightPx = TotalUsedHeightPx - MaxMouldingWidthPx * 2; // refers to the outer width, not the width of an individual side
            // if UseCommonDPI is turned on, we want to sync single doc, cameo, and spirit. We sync them in such a way that, if turned on their side, vertical frames will still fit.
            // calculate the maximum possible width of a single doc frame with this document size. This is used to establish a common DPI across all single docs when UseCommonDPI is set to true
            MaxSingleDocRailWidthPx = Math.max(
                <number>(<any>Math.round((<number>(<any>DocSizeTier.CameoRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder,
                <number>(<any>Math.round((<number>(<any>DocSizeTier.StandardRail) - MouldingOverlap) * DPI)) + SMatWidthPixelAdder + (BevelWidthPx * 2 + SMatWidthPx),
            ); // we use the larger cameo rail for this calculation. Also, compare against standard rail + fillet. Take the largest
            MaxPossibleSingleDocWidthPx = MaxSingleDocRailWidthPx * 2 + DocWidthPx + MaxMouldingWidthPx * 2;
            MaxPossibleSingleDocHeightPx = MaxSingleDocRailWidthPx * 2 + DocHeightPx + MaxMouldingWidthPx * 2;
            if (DocHeightPx > DocWidthPx && pcs.UseCommonDPI) {
                if (MaxPossibleSingleDocHeightPx > pcs.MaxFrameWidthPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            } else {
                if ((pcs.UseCommonDPI ? MaxPossibleSingleDocWidthPx : TotalUsedWidthPx_NoMargin) > pcs.MaxFrameWidthPx || (pcs.UseCommonDPI ? TotalUsedHeightPx : TotalUsedHeightPx_NoMargin) > pcs.MaxFrameHeightPx) {
                    DPI -= 1;
                } else {
                    done = true;
                }
            }
            doneCount += 1;
            if (doneCount > 100000) {
                done = true;
            }
        }

        // set DPI to a global object
        pcs.DPI = DPI;
        // check width, look back with new dpi if necessary
        pcs.FrameDisplay_width = TotalUsedWidthPx;
        pcs.FrameDisplay_height = TotalUsedHeightPx;
        // primary mat
        r.renderStandardPrimaryMat(pcs.FramePartDomain, PMatWidthPx, PMatHeightPx, MaxMouldingWidthPx, MouldingWidthPx, pcs);
        r.renderStandardMoulding(MouldingWidthPx, PMatWidthPx, PMatHeightPx, pcs);
        pcs.css.oval_visible = true;
        if (SMatCount > 0) {
            pcs.css.doc1_pmat_bevel_backgroundColor = `white`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx + OvalWidthPx + OvalGapPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${DocWidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
            pcs.css.doc1_pmat_bevel_height = `${DocHeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx)}px`;
            r.RenderStandardSMat(BevelWidthPx, SMatWidthPx, DocWidthPx, DocHeightPx, pcs);
            pcs.css.oval_pmat_bevel_backgroundColor = `white`;
            pcs.css.oval_pmat_bevel_left = `${(RailSidePx - SMatWidthPx - BevelWidthPx * 2).toString()}px`;
            pcs.css.oval_pmat_bevel_top = `${(<number>(<any>Math.floor((<number>(<any>PMatHeightPx) - <number>(<any>OvalHeightPx) - <number>(<any>SMatWidthPx) * 2) / 2))).toString()}px`;
            pcs.css.oval_pmat_bevel_width = `${(OvalWidthPx + SMatWidthPx * 2 + BevelWidthPx * 4).toString()}px`;
            pcs.css.oval_pmat_bevel_height = `${OvalHeightPx + SMatWidthPx * 2 + BevelWidthPx * 4}px`;
            pcs.css.oval_pmat_bevel_borderRadius = `${(OvalWidthPx + SMatWidthPx * 2 + BevelWidthPx * 4).toString()}px / ${(OvalHeightPx + SMatWidthPx * 2 + BevelWidthPx * 4).toString()}px`;
            pcs.css.oval_smat_backgroundColor = `#${pcs.SecondaryMatColor}`;
            pcs.css.oval_smat_left = `${BevelWidthPx.toString()}px`;
            pcs.css.oval_smat_top = `${BevelWidthPx.toString()}px`;
            pcs.css.oval_smat_width = `${(OvalWidthPx + 2 * (BevelWidthPx + SMatWidthPx)).toString()}px`;
            pcs.css.oval_smat_height = `${(OvalHeightPx + 2 * (BevelWidthPx + SMatWidthPx)).toString()}px`;
            pcs.css.oval_smat_borderRadius = `${(OvalWidthPx + 2 * (BevelWidthPx + SMatWidthPx)).toString()}px / ${(OvalHeightPx + 2 * (BevelWidthPx + SMatWidthPx)).toString()}px`;
            pcs.css.oval_smat_bevel_backgroundColor = `#FFFFFF`;
            pcs.css.oval_smat_bevel_left = `${SMatWidthPx.toString()}px`;
            pcs.css.oval_smat_bevel_top = `${SMatWidthPx.toString()}px`;
            pcs.css.oval_smat_bevel_width = `${(OvalWidthPx + 2 * BevelWidthPx).toString()}px`;
            pcs.css.oval_smat_bevel_height = `${(OvalHeightPx + 2 * BevelWidthPx).toString()}px`;
            pcs.css.oval_smat_bevel_borderRadius = `${(OvalWidthPx + 2 * BevelWidthPx).toString()}px / ${(OvalHeightPx + 2 * BevelWidthPx).toString()}px`;
        } else {
            pcs.css.doc1_pmat_bevel_backgroundColor = `#FFFFFF`;
            pcs.css.doc1_pmat_bevel_left = `${(RailSidePx + OvalWidthPx + OvalGapPx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_top = `${(RailTopPx - BevelWidthPx).toString()}px`;
            pcs.css.doc1_pmat_bevel_width = `${(DocWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.doc1_pmat_bevel_height = `${(DocHeightPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.oval_pmat_bevel_backgroundColor = `#FFFFFF`;
            pcs.css.oval_pmat_bevel_left = `${(RailSidePx - BevelWidthPx).toString()}px`;
            pcs.css.oval_pmat_bevel_top = `${(<number>(<any>Math.floor((<number>(<any>PMatHeightPx) - OvalHeightPx) / 2))).toString()}px`;
            pcs.css.oval_pmat_bevel_width = `${(OvalWidthPx + BevelWidthPx * 2).toString()}px`;
            pcs.css.oval_pmat_bevel_height = `${OvalHeightPx + BevelWidthPx * 2}px`;
            pcs.css.oval_pmat_bevel_borderRadius = `${OvalWidthPx.toString()}px / ${OvalHeightPx.toString()}px`;
            r.renderCollapsedSMat(pcs);
            pcs.css.oval_smat_backgroundColor = `none`;
            pcs.css.oval_smat_left = `0px`;
            pcs.css.oval_smat_top = `0px`;
            pcs.css.oval_smat_width = ``;
            pcs.css.oval_smat_height = ``;
            pcs.css.oval_smat_borderRadius = `0px`;
            pcs.css.oval_smat_bevel_backgroundColor = `none`;
            pcs.css.oval_smat_bevel_left = `0px`;
            pcs.css.oval_smat_bevel_top = `0px`;
            pcs.css.oval_smat_bevel_width = ``;
            pcs.css.oval_smat_bevel_height = ``;
            pcs.css.oval_smat_bevel_borderRadius = `0px`;
        }
        pcs.css.doc1_src = r.doc_path(pcs, DocWidthPx, DocHeightPx, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
        pcs.css.doc1_left = `${BevelWidthPx.toString()}px`;
        pcs.css.doc1_top = `${BevelWidthPx.toString()}px`;
        pcs.css.doc1_width = `${DocWidthPx.toString()}px`;
        pcs.css.doc1_height = `${DocHeightPx.toString()}px`;
        pcs.css.oval_src = r.oval_path(pcs.FramePartDomain, OvalWidthPx, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID);
        pcs.css.oval_left = `${BevelWidthPx.toString()}px`;
        pcs.css.oval_top = `${BevelWidthPx.toString()}px`;
        pcs.css.oval_width = `${OvalWidthPx.toString()}px`;
        pcs.css.oval_height = `${OvalHeightPx.toString()}px`;
        pcs.css.oval_borderRadius = `${OvalWidthPx.toString()}px / ${OvalHeightPx.toString()}px`;
        pcs.css.oval_backgroundColor = `#FFFFFF`;
        pcs.css.insignia_visible = pcs.Base_InsigniaID > 0;
        if (pcs.Base_InsigniaID > 0) {
            pcs.css.insignia_src = r.insignia_path(pcs.FramePartDomain, MaxInsigniaWidthPx, pcs.Base_InsigniaName);
            pcs.css.insignia_left = `${OvalWidthPx + OvalGapPx + <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))}px`;
            pcs.css.insignia_top = `${<number>(<any>Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>MaxInsigniaWidthPx) / 2))}px`;
            pcs.css.insignia_width = `${MaxInsigniaWidthPx.toString()}px`;
            pcs.css.insignia_height = `${MaxInsigniaWidthPx.toString()}px`;
        }
        pcs.css.lino_visible = pcs.Base_LinoID > 0;
        if (pcs.Base_LinoID > 0) {
            pcs.css.lino_src = r.lino_path(LinoWidthMaxPx, pcs);
            pcs.css.lino_left = `${OvalWidthPx + OvalGapPx + <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>LinoWidthMaxPx) / 2))}px`;
            pcs.css.lino_top = `${<number>(<any>(RailTopPx + DocHeightPx + BevelWidthPx + SMatCount * (SMatWidthPx + BevelWidthPx) + Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>LinoHeightMaxPx) / 2)))}px`;
            pcs.css.lino_width = `${LinoWidthMaxPx.toString()}px`;
            pcs.css.lino_height = `${LinoHeightMaxPx.toString()}px`;
        }
        // ep
        pcs.css.ep_visible = pcs.HasEngravedPlate;
        if (pcs.HasEngravedPlate) {
            let EPTopPx: number =
                <number>(
                    (<any>(
                        (RailTopPx +
                            DocHeightPx +
                            BevelWidthPx +
                            SMatCount * (SMatWidthPx + BevelWidthPx) +
                            Math.floor((<number>(<any>RailTopPx) - <number>(<any>BevelWidthPx) - <number>(<any>SMatCount) * (<number>(<any>SMatWidthPx) + <number>(<any>BevelWidthPx))) / 2 - <number>(<any>EPHeightPx) / 2))
                    ))
                ) -
                BevelWidthPx * 2;
            let EPLeftPx: number = OvalWidthPx + OvalGapPx + <number>(<any>Math.floor(<number>(<any>RailSidePx) + <number>(<any>DocWidthPx) / 2 - <number>(<any>EPWidthPx) / 2)) - BevelWidthPx * 2;
            r.renderEngravedPlate(EPLeftPx, EPTopPx, EPWidthPx, EPHeightPx, BevelWidthPx, PMatWidthPx, pcs);
        }
    };

    export const renderDoubleStack = (pcs: ProductCustomizationState): void => {
        const docWidth = pcs.Document_Width;
        const docHeight = pcs.Document_Height;
        const containerWidth = pcs.JF_Width;
        const containerHeight = pcs.JF_Height;

        pcs.css.double_stack_width = (docWidth / containerWidth) * 100;
        pcs.css.double_stack_height = (docHeight / containerHeight) * 100;
        pcs.css.double_stack_aspect_ratio = containerWidth / containerHeight;
        pcs.css.double_stack_is_vertical = pcs.css.double_stack_aspect_ratio < 1;
        pcs.css.doc1_src = r.doc_path(pcs, docWidth, docHeight, pcs.Base_DocumentName, pcs.Base_ExtraEntityName, pcs.DYF_FrameStyleID, pcs.o3);
    };

    const getRailBottomForDynamicEP = (pcs: ProductCustomizationState, RailTopPx: number, EPHeightPx: number) => {
        const addEPHeight = (pcs.EPMethodID === EPMethod.Extended && !!getEPLineCount(pcs)) || pcs.EPMethodID === EPMethod.Custom;

        return addEPHeight ? EPHeightPx + RailTopPx : RailTopPx;
    };

    const getEPHeight = (pcs: ProductCustomizationState, DPI: number, EPHeight: number, DocBevelHeightPx: number) => {
        let height: number;

        if (pcs.EPMethodID === EPMethod.Custom) {
            height = 8 * DPI;
        } else if (pcs.EPMethodID === EPMethod.SingleDoc) {
            height = DocBevelHeightPx;
        } else {
            height = EPHeight * DPI;
        }

        return height;
    };

    const getEPWidth = (pcs: ProductCustomizationState, DPI: number, EPWidth: number, DocBevelWidthPx: number) => {
        let width: number;

        if (pcs.EPMethodID === EPMethod.Custom) {
            width = 4 * DPI;
        } else if (pcs.EPMethodID === EPMethod.SingleDoc) {
            width = DocBevelWidthPx;
        } else {
            width = EPWidth * DPI;
        }

        return width;
    };

    const getDocBevelWidth = (SMatCount: number, DocWidthPx: number, BevelWidthPx: number, SMatWidthPx: number) => {
        if (SMatCount > 0) {
            return DocWidthPx + 2 * (BevelWidthPx * 2 + SMatWidthPx);
        } else {
            return DocWidthPx + BevelWidthPx * 2;
        }
    };

    const getDocBevelHeight = (SMatCount: number, DocHeightPx: number, BevelWidthPx: number, SMatWidthPx: number) => {
        if (SMatCount > 0) {
            return DocHeightPx + 2 * (BevelWidthPx * 2 + SMatWidthPx);
        } else {
            return DocHeightPx + BevelWidthPx * 2;
        }
    };
}
